
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3802"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3802"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dyfc6", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("lel8F").then(()=>parcelRequire("4kGcU"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


class $50cc705403a73ebf$export$4fae95256245c8c0 {
    on(event, listener) {
        if (typeof this.events[event] !== "object") this.events[event] = [];
        this.events[event].push(listener);
        return ()=>this.off(event, listener);
    }
    off(event, listener) {
        if (typeof this.events[event] !== "object") return;
        this.events[event] = this.events[event].filter((eventListener)=>eventListener !== listener);
    }
    offAll() {
        Object.keys(this.events).forEach((event)=>this.events[event] = []);
    }
    emit(event, ...args) {
        if (typeof this.events[event] === "object") [
            ...this.events[event]
        ].forEach((listener)=>listener.apply(this, args));
        [
            ...this.events["*"]
        ].forEach((listener)=>listener.apply(this, [
                event,
                ...args
            ]));
    }
    once(event, listener) {
        const remove = this.on(event, (...args)=>{
            remove();
            listener.apply(this, args);
        });
        return remove;
    }
    constructor(){
        this.events = {
            "*": []
        };
    }
}


class $403d562f8e068716$export$2e2bcd8739ae039 extends (0, $50cc705403a73ebf$export$4fae95256245c8c0) {
    constructor({ $target: $target, initialState: initialState }){
        super();
        this.$target = $target;
        this.state = initialState;
        this.init();
        this.render();
    }
    /**
     * Component state change logic
     *
     * @param newState state value to change
     * @param preventRender If true, no rendering is done after the state is changed.
     * @param callback If set, called back if state has changed.
     */ setState(newState, preventRender, callback) {
        if (!this.checkNeedUpdate(newState)) return;
        if (this.state) this.state = {
            ...this.state,
            ...newState
        };
        else this.state = {
            ...newState
        };
        if (callback) {
            callback();
            return;
        }
        if (preventRender) return;
        this.render();
    }
    /**
     * Component state validation, basic... can use more advanced like fast-deep-equal package
     *
     * @param newState state value to validate
     */ checkNeedUpdate(newState) {
        const prevState = JSON.stringify({
            ...this.state
        });
        const currentState = JSON.stringify({
            ...this.state,
            ...newState
        });
        return prevState !== currentState;
    }
}



var $20654a4b7519d360$var$Urls;
(function(Urls) {
    Urls["mapJS"] = "https://sdk.woosmap.com/map/map.js";
    Urls["widgetJS"] = "https://sdk.woosmap.com/map/widgets.js";
    Urls["lambdaExternal"] = "https://t0a2tbeh90.execute-api.eu-west-1.amazonaws.com/default/woosmap-service-sdm-id";
    Urls["favMarkerUrl"] = "https://indoor.woosmap.com/salone-del-mobile-stage/assets/Pin-to-be-visted@3x.png";
})($20654a4b7519d360$var$Urls || ($20654a4b7519d360$var$Urls = {}));
var $20654a4b7519d360$export$2e2bcd8739ae039 = $20654a4b7519d360$var$Urls;


var $1b81979ac4ba0c49$export$2e2bcd8739ae039 = {
    thematics: [
        {
            id: 1,
            title: "Smart Office",
            ref: "smartoffice",
            description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
        },
        {
            id: 2,
            title: "Eclectic Design",
            ref: "eclectic",
            description: "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship."
        },
        {
            id: 3,
            title: "Domestic Outdoor lighting",
            ref: "dol",
            description: "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics."
        },
        {
            id: 4,
            title: "Urban Outdoor lighting",
            ref: "uol",
            description: "Highly innovative interiors: water sustainability according to Salotto NY."
        },
        {
            id: 5,
            title: "Home Entertainment",
            ref: "homent",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        },
        {
            id: 6,
            title: "Umbrellas and Pergolas",
            ref: "umbrella",
            description: "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces."
        },
        {
            id: 7,
            title: "Wallpaper",
            ref: "wallpaper",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        },
        {
            id: 8,
            title: "Rugs",
            ref: "rug",
            description: "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces."
        }
    ]
};


/**
 * Language: English.
 */ var $ce6b24fd3f3f3a3b$export$2e2bcd8739ae039 = {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1",
        allexhibits: "All exhibitors",
        favorites: "Your exhibitors",
        select_thematic: "Select Thematics",
        allexhibits_mobile: "See all",
        favorites_mobile: "Your list",
        select_thematic_mobile: "Theme path",
        add_favorites: "Add to your exhibitors",
        remove_favorites: "Remove from your exhibitors",
        add_favorites_toast: "Exhibitor added to your list",
        remove_favorites_toast: "Exhibitor removed from your list",
        api_error: "You need to login to access your exhibitors",
        level: "Level"
    },
    thematics: {
        "umbrella": "Umbrellas and Pergolas",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Rugs"
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY."
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    }
};


/**
 * Language: Italian.
 */ var $7cc7518b768c600c$export$2e2bcd8739ae039 = {
    "messages": {
        "choose_thematic": "Scegli Tematica",
        "sessionReset": "La sessione si reimposter\xe0 automaticamente tra",
        "minute": "minuto",
        "resetMap": "Reimposta Mappa",
        "selectLanguage": "Seleziona una Lingua",
        "seconds": "secondi",
        "cta": {
            "switch_standard_view": "Passa alla visualizzazione standard"
        },
        "minutes": "minuti",
        "multilevelwarning": "Questo percorso \xe8 su due livelli e passa anche per il Quick Link a livello 1",
        "allexhibits": "Tutti gli espositori",
        "favorites": "I tuoi espositori",
        "select_thematic": "Percorsi tematici",
        "add_favorites": "Aggiungi ai tuoi espositori",
        "remove_favorites": "Rimuovi dai tuoi espositori",
        "add_favorites_toast": "Espositore aggiunto alla tua lista",
        "remove_favorites_toast": "Espositore rimosso dalla tua lista",
        "level": "Livello",
        "allexhibits_mobile": "Tutti",
        "favorites_mobile": "La tua lista",
        "select_thematic_mobile": "Percorsi a tema",
        "api_error": "Devi effettuare il login per accedere ai tuoi espositori"
    },
    "thematics": {
        "umbrella": "Ombrelloni e pergole",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Tappeti"
    },
    "thematicDescription": {
        "outdoor": "Design, durabilit\xe0 e comfort: evoluzione continua per arredare giardini, terrazzi e spazi di piccole dimensioni.",
        "textile": "Percorsi tessili che intrecciano tecnologie pi\xf9 avanzate e inconfondibile segno artigianale.",
        "wallpaper": "Soluzioni e ricerche tra materiali, pattern e colori che uniscono tecnica ed estetica.",
        "kitchen": "Progetti, arredi su misura e soluzioni per hotel, residence, uffici e retail.",
        "bathroom": "Arredi ad alto tasso di innovazione: la sostenibilit\xe0 idrica secondo Salotto NY."
    },
    "errors": {
        "loadingLibrary": "Impossibile caricare lo script {library}",
        "geolocationFailed": "Geolocalizzazione dell'utente fallita",
        "apiErrors": {
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore interno del server",
            "other": "Si \xe8 verificato un errore imprevisto del server"
        }
    }
};



const $58070e9281bc680d$var$LOCALE_EN = "EN";
const $58070e9281bc680d$var$DEFAULT_LOCALE = $58070e9281bc680d$var$LOCALE_EN;
let $58070e9281bc680d$var$USER_LOCALE;
const $58070e9281bc680d$var$localeStorage = {};
const $58070e9281bc680d$export$9a2147b3808d4c6b = function() {
    return $58070e9281bc680d$var$DEFAULT_LOCALE;
}();
function $58070e9281bc680d$var$registerLocale(locale, localeObj) {
    locale = locale.toUpperCase();
    $58070e9281bc680d$var$localeStorage[locale] = localeObj;
}
function $58070e9281bc680d$export$ddc371781a6af754(lang, localeObj) {
    if (lang) {
        const localeObj = $58070e9281bc680d$var$localeStorage[lang.toUpperCase()] || {};
        if (lang === $58070e9281bc680d$var$LOCALE_EN) return {
            ...localeObj
        };
        else return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
            ...localeObj
        }, {
            ...$58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE]
        });
    } else return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
        ...localeObj
    }, {
        ...$58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE]
    });
}
function $58070e9281bc680d$export$e6103b0362967aab(lang) {
    if (lang) {
        console.log("Lang ", lang);
        $58070e9281bc680d$var$USER_LOCALE = lang;
        const userLocale = $58070e9281bc680d$export$ddc371781a6af754(lang);
        $58070e9281bc680d$var$registerLocale(lang, userLocale);
    }
}
function $58070e9281bc680d$export$180605366c04f0cd(lang) {
    if (lang) return $58070e9281bc680d$var$localeStorage[lang];
    else if ($58070e9281bc680d$var$USER_LOCALE) return $58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$USER_LOCALE];
    else return $58070e9281bc680d$var$localeStorage[$58070e9281bc680d$var$DEFAULT_LOCALE];
}
function $58070e9281bc680d$export$3814be8b8b1016be() {
    return $58070e9281bc680d$var$USER_LOCALE || $58070e9281bc680d$var$DEFAULT_LOCALE;
}
function $58070e9281bc680d$export$665560c9ff312dd4() {
    return (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
}
function $58070e9281bc680d$export$236350842f3cd9bc(localeObj, key) {
    if (localeObj[key] !== undefined && typeof localeObj[key] === "string") return localeObj[key];
    else return key;
}
$58070e9281bc680d$var$registerLocale($58070e9281bc680d$var$LOCALE_EN, (0, $ce6b24fd3f3f3a3b$export$2e2bcd8739ae039));
$58070e9281bc680d$var$registerLocale("IT", (0, $7cc7518b768c600c$export$2e2bcd8739ae039));


var $03005ecb18aee849$export$2e2bcd8739ae039 = {
    buildings: [
        {
            ref: "pav1_3",
            title: "P 01-03",
            pavilion: [
                "pav1",
                "pav3"
            ],
            thematics: [
                "umbrella",
                "homent",
                "smartoffice",
                "eclectic",
                "rug",
                "dol"
            ],
            center: {
                lat: 45.517404547972504,
                lng: 9.0829660782425
            }
        },
        {
            ref: "pav2_4",
            title: "P 02-04",
            pavilion: [
                "pav2",
                "pav4"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {
                lat: 45.51977094554,
                lng: 9.084641596885
            }
        },
        {
            ref: "pav5_7",
            title: "P 05-07",
            pavilion: [
                "pav5",
                "pav7"
            ],
            thematics: [
                "wallpaper",
                "umbrella",
                "homent",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.518486051029996,
                lng: 9.08057912806
            }
        },
        {
            ref: "pav6_10",
            title: "P 06-10",
            pavilion: [
                "pav6",
                "pav10"
            ],
            thematics: [
                "dol",
                "uol"
            ],
            center: {
                lat: 45.52043912007,
                lng: 9.081303605317501
            }
        },
        {
            ref: "pav9_11",
            title: "P 09-11",
            pavilion: [
                "pav9",
                "pav11"
            ],
            thematics: [
                "homent",
                "smartoffice"
            ],
            center: {
                lat: 45.519864817035,
                lng: 9.075825940384998
            }
        },
        {
            ref: "pav13_15",
            title: "P 13-15",
            pavilion: [
                "pav13",
                "pav15"
            ],
            thematics: [
                "homent",
                "wallpaper",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.5207451646875,
                lng: 9.073293433275
            }
        },
        {
            ref: "pav14_18",
            title: "P 14-18",
            pavilion: [
                "pav14",
                "pav18"
            ],
            thematics: [
                "wallpaper",
                "homent",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.5216703575,
                lng: 9.0777833391
            }
        },
        {
            ref: "pav22_24",
            title: "P 22-24",
            pavilion: [
                "pav22",
                "pav24"
            ],
            thematics: [
                "umbrella",
                "wallpaper",
                "smartoffice",
                "eclectic",
                "rug"
            ],
            center: {
                lat: 45.52294009775724,
                lng: 9.074819554722694
            }
        }
    ]
};


// index.ts
// index.ts
// index.js
// index.ts
var $99d87cb8abf11eaa$export$e3a1ee0e9945697f = 63710088e-1;
var $99d87cb8abf11eaa$export$f929e47acbed771a = {
    centimeters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 100,
    centimetres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 3.28084,
    inches: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 39.37,
    kilometers: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1e3,
    kilometres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1e3,
    meters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f,
    metres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f,
    miles: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1e3,
    millimetres: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $99d87cb8abf11eaa$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $99d87cb8abf11eaa$export$e3a1ee0e9945697f * 1.0936
};
var $99d87cb8abf11eaa$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $99d87cb8abf11eaa$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $99d87cb8abf11eaa$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $99d87cb8abf11eaa$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $99d87cb8abf11eaa$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $99d87cb8abf11eaa$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $99d87cb8abf11eaa$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $99d87cb8abf11eaa$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$99d87cb8abf11eaa$export$7e4aa119212bc614(coordinates[0]) || !$99d87cb8abf11eaa$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $99d87cb8abf11eaa$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $99d87cb8abf11eaa$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $99d87cb8abf11eaa$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $99d87cb8abf11eaa$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $99d87cb8abf11eaa$export$ced6ed16dfd6a264(geom, properties, options);
}
function $99d87cb8abf11eaa$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $99d87cb8abf11eaa$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $99d87cb8abf11eaa$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $99d87cb8abf11eaa$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $99d87cb8abf11eaa$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $99d87cb8abf11eaa$export$c7a138e00a89bd01(distance, units) {
    return $99d87cb8abf11eaa$export$c41dd2a8460d3196($99d87cb8abf11eaa$export$a2280f7debae8f10(distance, units));
}
function $99d87cb8abf11eaa$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $99d87cb8abf11eaa$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $99d87cb8abf11eaa$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $99d87cb8abf11eaa$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $99d87cb8abf11eaa$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $99d87cb8abf11eaa$export$f234631d6a2eedf8($99d87cb8abf11eaa$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $99d87cb8abf11eaa$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $99d87cb8abf11eaa$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $99d87cb8abf11eaa$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $99d87cb8abf11eaa$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $99d87cb8abf11eaa$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $99d87cb8abf11eaa$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$99d87cb8abf11eaa$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $99d87cb8abf11eaa$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


function $3585f2d1a61dd970$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($3585f2d1a61dd970$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $3585f2d1a61dd970$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $3585f2d1a61dd970$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $3585f2d1a61dd970$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $3585f2d1a61dd970$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $3585f2d1a61dd970$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $3585f2d1a61dd970$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, callback) {
    $3585f2d1a61dd970$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $3585f2d1a61dd970$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$d3ecc1efb2be121e(geojson, callback) {
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($3585f2d1a61dd970$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $3585f2d1a61dd970$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $3585f2d1a61dd970$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $3585f2d1a61dd970$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $99d87cb8abf11eaa$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $3585f2d1a61dd970$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $3585f2d1a61dd970$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $3585f2d1a61dd970$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $99d87cb8abf11eaa$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $99d87cb8abf11eaa$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $3585f2d1a61dd970$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $99d87cb8abf11eaa$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}



function $40b1a25d9324c658$export$7b82f38e9ee2ae8(geojson) {
    const points = [];
    if (geojson.type === "FeatureCollection") (0, $3585f2d1a61dd970$export$45a31c4de8035258)(geojson, function(feature) {
        (0, $3585f2d1a61dd970$export$6e011439fde007ae)(feature, function(coord) {
            points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord, feature.properties));
        });
    });
    else if (geojson.type === "Feature") (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, function(coord) {
        points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord, geojson.properties));
    });
    else (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, function(coord) {
        points.push((0, $99d87cb8abf11eaa$export$105684a3041cb6f3)(coord));
    });
    return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)(points);
}
var $40b1a25d9324c658$export$2e2bcd8739ae039 = $40b1a25d9324c658$export$7b82f38e9ee2ae8;


// index.ts
// index.ts

function $72da53fb4eeebf24$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $3585f2d1a61dd970$export$6e011439fde007ae)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var $72da53fb4eeebf24$export$2e2bcd8739ae039 = $72da53fb4eeebf24$export$bf67010aacbe66fa;



function $4e1112713e478267$export$3481c78889e8fbe8(geojson, options = {}) {
    const ext = (0, $72da53fb4eeebf24$export$bf67010aacbe66fa)(geojson);
    const x = (ext[0] + ext[2]) / 2;
    const y = (ext[1] + ext[3]) / 2;
    return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)([
        x,
        y
    ], options.properties, options);
}
var $4e1112713e478267$export$2e2bcd8739ae039 = $4e1112713e478267$export$3481c78889e8fbe8;


// index.ts
function $15d3c242213cacca$export$9cd59f9826255e47(geojson) {
    if (!geojson) throw new Error("geojson is required");
    switch(geojson.type){
        case "Feature":
            return $15d3c242213cacca$var$cloneFeature(geojson);
        case "FeatureCollection":
            return $15d3c242213cacca$var$cloneFeatureCollection(geojson);
        case "Point":
        case "LineString":
        case "Polygon":
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
        case "GeometryCollection":
            return $15d3c242213cacca$var$cloneGeometry(geojson);
        default:
            throw new Error("unknown GeoJSON type");
    }
}
function $15d3c242213cacca$var$cloneFeature(geojson) {
    const cloned = {
        type: "Feature"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "properties":
            case "geometry":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.properties = $15d3c242213cacca$export$dc8a742a89aa85b4(geojson.properties);
    if (geojson.geometry == null) cloned.geometry = null;
    else cloned.geometry = $15d3c242213cacca$var$cloneGeometry(geojson.geometry);
    return cloned;
}
function $15d3c242213cacca$export$dc8a742a89aa85b4(properties) {
    const cloned = {};
    if (!properties) return cloned;
    Object.keys(properties).forEach((key)=>{
        const value = properties[key];
        if (typeof value === "object") {
            if (value === null) cloned[key] = null;
            else if (Array.isArray(value)) cloned[key] = value.map((item)=>{
                return item;
            });
            else cloned[key] = $15d3c242213cacca$export$dc8a742a89aa85b4(value);
        } else cloned[key] = value;
    });
    return cloned;
}
function $15d3c242213cacca$var$cloneFeatureCollection(geojson) {
    const cloned = {
        type: "FeatureCollection"
    };
    Object.keys(geojson).forEach((key)=>{
        switch(key){
            case "type":
            case "features":
                return;
            default:
                cloned[key] = geojson[key];
        }
    });
    cloned.features = geojson.features.map((feature)=>{
        return $15d3c242213cacca$var$cloneFeature(feature);
    });
    return cloned;
}
function $15d3c242213cacca$var$cloneGeometry(geometry) {
    const geom = {
        type: geometry.type
    };
    if (geometry.bbox) geom.bbox = geometry.bbox;
    if (geometry.type === "GeometryCollection") {
        geom.geometries = geometry.geometries.map((g)=>{
            return $15d3c242213cacca$var$cloneGeometry(g);
        });
        return geom;
    }
    geom.coordinates = $15d3c242213cacca$var$deepSlice(geometry.coordinates);
    return geom;
}
function $15d3c242213cacca$var$deepSlice(coords) {
    const cloned = coords;
    if (typeof cloned[0] !== "object") return cloned.slice();
    return cloned.map((coord)=>{
        return $15d3c242213cacca$var$deepSlice(coord);
    });
}
var $15d3c242213cacca$export$2e2bcd8739ae039 = $15d3c242213cacca$export$9cd59f9826255e47;


// index.ts
// index.ts

function $9b195126e45e4c4e$export$b4663c6e64a770bc(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return [
            ...coord.geometry.coordinates
        ];
        if (coord.type === "Point") return [
            ...coord.coordinates
        ];
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return [
        ...coord
    ];
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function $9b195126e45e4c4e$export$39e042fd83f1b62e(coords) {
    if (Array.isArray(coords)) return coords;
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function $9b195126e45e4c4e$export$ab82360ed81b09b9(coordinates) {
    if (coordinates.length > 1 && (0, $99d87cb8abf11eaa$export$7e4aa119212bc614)(coordinates[0]) && (0, $99d87cb8abf11eaa$export$7e4aa119212bc614)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return $9b195126e45e4c4e$export$ab82360ed81b09b9(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function $9b195126e45e4c4e$export$329ecc560bd873a7(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function $9b195126e45e4c4e$export$8b96d9ca92084402(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function $9b195126e45e4c4e$export$bcf04c9d01e728b6(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for (const feature of featureCollection.features){
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function $9b195126e45e4c4e$export$b8f320eb9549c8fd(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function $9b195126e45e4c4e$export$e2b5c5db9e2009fd(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}



function $35bc333ffaf3f0e9$export$9f17032d917177de(from, to, options = {}) {
    var coordinates1 = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(from);
    var coordinates2 = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(to);
    var dLat = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[1] - coordinates1[1]);
    var dLon = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[0] - coordinates1[0]);
    var lat1 = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates1[1]);
    var lat2 = (0, $99d87cb8abf11eaa$export$c9fcf1a7df975d78)(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return (0, $99d87cb8abf11eaa$export$f234631d6a2eedf8)(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}
var $35bc333ffaf3f0e9$export$2e2bcd8739ae039 = $35bc333ffaf3f0e9$export$9f17032d917177de;



var $cdae9ad4d14de8da$var$__defProp = Object.defineProperty;
var $cdae9ad4d14de8da$var$__defProps = Object.defineProperties;
var $cdae9ad4d14de8da$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cdae9ad4d14de8da$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cdae9ad4d14de8da$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cdae9ad4d14de8da$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cdae9ad4d14de8da$var$__defNormalProp = (obj, key, value)=>key in obj ? $cdae9ad4d14de8da$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cdae9ad4d14de8da$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cdae9ad4d14de8da$var$__hasOwnProp.call(b, prop)) $cdae9ad4d14de8da$var$__defNormalProp(a, prop, b[prop]);
    if ($cdae9ad4d14de8da$var$__getOwnPropSymbols) {
        for (var prop of $cdae9ad4d14de8da$var$__getOwnPropSymbols(b))if ($cdae9ad4d14de8da$var$__propIsEnum.call(b, prop)) $cdae9ad4d14de8da$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cdae9ad4d14de8da$var$__spreadProps = (a, b)=>$cdae9ad4d14de8da$var$__defProps(a, $cdae9ad4d14de8da$var$__getOwnPropDescs(b));
function $cdae9ad4d14de8da$export$ba330bb14d26e4ac(targetPoint, points, options = {}) {
    if (!targetPoint) throw new Error("targetPoint is required");
    if (!points) throw new Error("points is required");
    let minDist = Infinity;
    let bestFeatureIndex = 0;
    (0, $3585f2d1a61dd970$export$45a31c4de8035258)(points, (pt, featureIndex)=>{
        const distanceToPoint = (0, $35bc333ffaf3f0e9$export$9f17032d917177de)(targetPoint, pt, options);
        if (distanceToPoint < minDist) {
            bestFeatureIndex = featureIndex;
            minDist = distanceToPoint;
        }
    });
    const nearestPoint2 = (0, $15d3c242213cacca$export$9cd59f9826255e47)(points.features[bestFeatureIndex]);
    return $cdae9ad4d14de8da$var$__spreadProps($cdae9ad4d14de8da$var$__spreadValues({}, nearestPoint2), {
        properties: $cdae9ad4d14de8da$var$__spreadProps($cdae9ad4d14de8da$var$__spreadValues({}, nearestPoint2.properties), {
            featureIndex: bestFeatureIndex,
            distanceToPoint: minDist
        })
    });
}
var $cdae9ad4d14de8da$export$2e2bcd8739ae039 = $cdae9ad4d14de8da$export$ba330bb14d26e4ac;


// index.ts
const $b7be22ffc815751f$export$6c421550c66a327d = 1.1102230246251565e-16;
const $b7be22ffc815751f$export$8cfde575cbd41e40 = 134217729;
const $b7be22ffc815751f$export$a4103c3ab16b06d7 = (3 + 8 * $b7be22ffc815751f$export$6c421550c66a327d) * $b7be22ffc815751f$export$6c421550c66a327d;
function $b7be22ffc815751f$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $b7be22ffc815751f$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $b7be22ffc815751f$export$8a63f25cc62965f1($b7be22ffc815751f$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $b7be22ffc815751f$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $b7be22ffc815751f$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $b7be22ffc815751f$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $b7be22ffc815751f$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $b7be22ffc815751f$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $b7be22ffc815751f$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $b7be22ffc815751f$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $a080ad2b3b4d3b31$var$ccwerrboundA = (3 + 16 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$ccwerrboundB = (2 + 12 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$ccwerrboundC = (9 + 64 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $a080ad2b3b4d3b31$var$B = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $a080ad2b3b4d3b31$var$C1 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $a080ad2b3b4d3b31$var$C2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(12);
const $a080ad2b3b4d3b31$var$D = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $a080ad2b3b4d3b31$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
function $a080ad2b3b4d3b31$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$B[3] = u3;
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(4, $a080ad2b3b4d3b31$var$B);
    let errbound = $a080ad2b3b4d3b31$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $a080ad2b3b4d3b31$var$ccwerrboundC * detsum + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const C1len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $a080ad2b3b4d3b31$var$B, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$C1);
    s1 = acx * bcytail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const C2len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(C1len, $a080ad2b3b4d3b31$var$C1, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $a080ad2b3b4d3b31$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $a080ad2b3b4d3b31$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $a080ad2b3b4d3b31$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $a080ad2b3b4d3b31$var$u[3] = u3;
    const Dlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(C2len, $a080ad2b3b4d3b31$var$C2, 4, $a080ad2b3b4d3b31$var$u, $a080ad2b3b4d3b31$var$D);
    return $a080ad2b3b4d3b31$var$D[Dlen - 1];
}
function $a080ad2b3b4d3b31$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $a080ad2b3b4d3b31$var$ccwerrboundA * detsum) return det;
    return -$a080ad2b3b4d3b31$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $a080ad2b3b4d3b31$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $cdc6986ffa648f91$var$o3derrboundA = (7 + 56 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$o3derrboundB = (3 + 28 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$o3derrboundC = (26 + 288 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $cdc6986ffa648f91$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$at_b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$at_c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bt_c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bt_a = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ct_a = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$ct_b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$bct = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$cat = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$abt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $cdc6986ffa648f91$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_8b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $cdc6986ffa648f91$var$_12 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(12);
let $cdc6986ffa648f91$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
let $cdc6986ffa648f91$var$fin2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
function $cdc6986ffa648f91$var$finadd(finlen, alen, a) {
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(finlen, $cdc6986ffa648f91$var$fin, alen, a, $cdc6986ffa648f91$var$fin2);
    const tmp = $cdc6986ffa648f91$var$fin;
    $cdc6986ffa648f91$var$fin = $cdc6986ffa648f91$var$fin2;
    $cdc6986ffa648f91$var$fin2 = tmp;
    return finlen;
}
function $cdc6986ffa648f91$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $cdc6986ffa648f91$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $cdc6986ffa648f91$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $cdc6986ffa648f91$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $cdc6986ffa648f91$var$u[2] = _k - (u3 - _j);
    $cdc6986ffa648f91$var$u[3] = u3;
    finlen = $cdc6986ffa648f91$var$finadd(finlen, 4, $cdc6986ffa648f91$var$u);
    if (z !== 0) {
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $cdc6986ffa648f91$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $cdc6986ffa648f91$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $cdc6986ffa648f91$var$u[2] = _k - (u3 - _j);
        $cdc6986ffa648f91$var$u[3] = u3;
        finlen = $cdc6986ffa648f91$var$finadd(finlen, 4, $cdc6986ffa648f91$var$u);
    }
    return finlen;
}
function $cdc6986ffa648f91$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $cdc6986ffa648f91$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $cdc6986ffa648f91$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $cdc6986ffa648f91$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $cdc6986ffa648f91$var$ab[3] = u3;
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$bc, adz, $cdc6986ffa648f91$var$_8), $cdc6986ffa648f91$var$_8, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ca, bdz, $cdc6986ffa648f91$var$_8b), $cdc6986ffa648f91$var$_8b, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ab, cdz, $cdc6986ffa648f91$var$_8), $cdc6986ffa648f91$var$_8, $cdc6986ffa648f91$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $cdc6986ffa648f91$var$fin);
    let errbound = $cdc6986ffa648f91$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $cdc6986ffa648f91$var$o3derrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $cdc6986ffa648f91$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $cdc6986ffa648f91$var$at_b, $cdc6986ffa648f91$var$at_c);
    const bt_len = $cdc6986ffa648f91$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $cdc6986ffa648f91$var$bt_c, $cdc6986ffa648f91$var$bt_a);
    const ct_len = $cdc6986ffa648f91$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $cdc6986ffa648f91$var$ct_a, $cdc6986ffa648f91$var$ct_b);
    const bctlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(bt_len, $cdc6986ffa648f91$var$bt_c, ct_len, $cdc6986ffa648f91$var$ct_b, $cdc6986ffa648f91$var$bct);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $cdc6986ffa648f91$var$bct, adz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    const catlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(ct_len, $cdc6986ffa648f91$var$ct_a, at_len, $cdc6986ffa648f91$var$at_c, $cdc6986ffa648f91$var$cat);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $cdc6986ffa648f91$var$cat, bdz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    const abtlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(at_len, $cdc6986ffa648f91$var$at_b, bt_len, $cdc6986ffa648f91$var$bt_a, $cdc6986ffa648f91$var$abt);
    finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $cdc6986ffa648f91$var$abt, cdz, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    if (adztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$bc, adztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $cdc6986ffa648f91$var$bct, adztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ca, bdztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $cdc6986ffa648f91$var$cat, bdztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $cdc6986ffa648f91$var$ab, cdztail, $cdc6986ffa648f91$var$_12), $cdc6986ffa648f91$var$_12);
        finlen = $cdc6986ffa648f91$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $cdc6986ffa648f91$var$abt, cdztail, $cdc6986ffa648f91$var$_16), $cdc6986ffa648f91$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $cdc6986ffa648f91$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $cdc6986ffa648f91$var$fin[finlen - 1];
}
function $cdc6986ffa648f91$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $cdc6986ffa648f91$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $cdc6986ffa648f91$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $cdc6986ffa648f91$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $39d7b03a6050569c$var$iccerrboundA = (10 + 96 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$iccerrboundB = (4 + 48 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$iccerrboundC = (44 + 576 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $39d7b03a6050569c$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$ca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$aa = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$bb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$cc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$u = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$v = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$axtbc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$aytbc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bxtca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bytca = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cxtab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cytab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$abt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$bct = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$cat = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$abtt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$bctt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$catt = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $39d7b03a6050569c$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $39d7b03a6050569c$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_16b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_16c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $39d7b03a6050569c$var$_32 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(32);
const $39d7b03a6050569c$var$_32b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(32);
const $39d7b03a6050569c$var$_48 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $39d7b03a6050569c$var$_64 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(64);
let $39d7b03a6050569c$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
let $39d7b03a6050569c$var$fin2 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
function $39d7b03a6050569c$var$finadd(finlen, a, alen) {
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(finlen, $39d7b03a6050569c$var$fin, a, alen, $39d7b03a6050569c$var$fin2);
    const tmp = $39d7b03a6050569c$var$fin;
    $39d7b03a6050569c$var$fin = $39d7b03a6050569c$var$fin2;
    $39d7b03a6050569c$var$fin2 = tmp;
    return finlen;
}
function $39d7b03a6050569c$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $39d7b03a6050569c$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $39d7b03a6050569c$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $39d7b03a6050569c$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $39d7b03a6050569c$var$ab[3] = u3;
    finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, ady, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, ady, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdy, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32b), $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdx, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdy, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $39d7b03a6050569c$var$fin);
    let errbound = $39d7b03a6050569c$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $39d7b03a6050569c$var$iccerrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $39d7b03a6050569c$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $39d7b03a6050569c$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $39d7b03a6050569c$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $39d7b03a6050569c$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adxtail, $39d7b03a6050569c$var$axtbc);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(axtbclen, $39d7b03a6050569c$var$axtbc, 2 * adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -cdy, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bc, adytail, $39d7b03a6050569c$var$aytbc);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(aytbclen, $39d7b03a6050569c$var$aytbc, 2 * ady, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, adytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -bdx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdxtail, $39d7b03a6050569c$var$bxtca);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bxtcalen, $39d7b03a6050569c$var$bxtca, 2 * bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdy, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -ady, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ca, bdytail, $39d7b03a6050569c$var$bytca);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bytcalen, $39d7b03a6050569c$var$bytca, 2 * bdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, bdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -cdx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdxtail, $39d7b03a6050569c$var$cxtab);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cxtablen, $39d7b03a6050569c$var$cxtab, 2 * cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, ady, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -bdy, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$ab, cdytail, $39d7b03a6050569c$var$cytab);
        finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cytablen, $39d7b03a6050569c$var$cytab, 2 * cdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, cdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdx, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdytail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, -adx, $39d7b03a6050569c$var$_16c), $39d7b03a6050569c$var$_16c, $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            bctlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $39d7b03a6050569c$var$bct[0] = 0;
            bctlen = 1;
            $39d7b03a6050569c$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $39d7b03a6050569c$var$bct, adxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(axtbclen, $39d7b03a6050569c$var$axtbc, adxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * adx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bcttlen, $39d7b03a6050569c$var$bctt, adxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * adx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, adxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, adxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (bdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (cdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, -adxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bctlen, $39d7b03a6050569c$var$bct, adytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(aytbclen, $39d7b03a6050569c$var$aytbc, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * ady, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(bcttlen, $39d7b03a6050569c$var$bctt, adytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * ady, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, adytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            catlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $39d7b03a6050569c$var$cat[0] = 0;
            catlen = 1;
            $39d7b03a6050569c$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $39d7b03a6050569c$var$cat, bdxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bxtcalen, $39d7b03a6050569c$var$bxtca, bdxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * bdx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(cattlen, $39d7b03a6050569c$var$catt, bdxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * bdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, bdxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, bdxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (cdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (adytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$cc, -bdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(catlen, $39d7b03a6050569c$var$cat, bdytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(bytcalen, $39d7b03a6050569c$var$bytca, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * bdy, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(cattlen, $39d7b03a6050569c$var$catt, bdytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * bdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, bdytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $39d7b03a6050569c$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $39d7b03a6050569c$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$v[3] = u3;
            abtlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)(4, $39d7b03a6050569c$var$u, 4, $39d7b03a6050569c$var$v, $39d7b03a6050569c$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $39d7b03a6050569c$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $39d7b03a6050569c$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $39d7b03a6050569c$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $39d7b03a6050569c$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $39d7b03a6050569c$var$abt[0] = 0;
            abtlen = 1;
            $39d7b03a6050569c$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $39d7b03a6050569c$var$abt, cdxtail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cxtablen, $39d7b03a6050569c$var$cxtab, cdxtail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * cdx, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abttlen, $39d7b03a6050569c$var$abtt, cdxtail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * cdx, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, cdxtail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, cdxtail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
            if (adytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$bb, cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, adytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
            if (bdytail !== 0) finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, $39d7b03a6050569c$var$aa, -cdxtail, $39d7b03a6050569c$var$_8), $39d7b03a6050569c$var$_8, bdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abtlen, $39d7b03a6050569c$var$abt, cdytail, $39d7b03a6050569c$var$_16c);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(cytablen, $39d7b03a6050569c$var$cytab, cdytail, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, 2 * cdy, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_48), $39d7b03a6050569c$var$_48);
            const len2 = (0, $b7be22ffc815751f$export$dcdf75081b88279d)(abttlen, $39d7b03a6050569c$var$abtt, cdytail, $39d7b03a6050569c$var$_8);
            finlen = $39d7b03a6050569c$var$finadd(finlen, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, 2 * cdy, $39d7b03a6050569c$var$_16), $39d7b03a6050569c$var$_16, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len2, $39d7b03a6050569c$var$_8, cdytail, $39d7b03a6050569c$var$_16b), $39d7b03a6050569c$var$_16b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $39d7b03a6050569c$var$_16c, cdytail, $39d7b03a6050569c$var$_32), $39d7b03a6050569c$var$_32, $39d7b03a6050569c$var$_32b, $39d7b03a6050569c$var$_64), $39d7b03a6050569c$var$_64);
        }
    }
    return $39d7b03a6050569c$var$fin[finlen - 1];
}
function $39d7b03a6050569c$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $39d7b03a6050569c$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $39d7b03a6050569c$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $39d7b03a6050569c$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $81600ebf6aa664b1$var$isperrboundA = (16 + 224 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$isperrboundB = (5 + 72 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$isperrboundC = (71 + 1408 * (0, $b7be22ffc815751f$export$6c421550c66a327d)) * (0, $b7be22ffc815751f$export$6c421550c66a327d) * (0, $b7be22ffc815751f$export$6c421550c66a327d);
const $81600ebf6aa664b1$var$ab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$bc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$cd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$de = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ea = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ac = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$bd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$ce = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$da = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$eb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(4);
const $81600ebf6aa664b1$var$abc = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$bcd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$cde = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$dea = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$eab = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$abd = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$bce = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$cda = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$deb = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$eac = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$adet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$bdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$cdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$ddet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$edet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
const $81600ebf6aa664b1$var$abdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(2304);
const $81600ebf6aa664b1$var$cddet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(2304);
const $81600ebf6aa664b1$var$cdedet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(3456);
const $81600ebf6aa664b1$var$deter = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(5760);
const $81600ebf6aa664b1$var$_8 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_8b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_8c = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(8);
const $81600ebf6aa664b1$var$_16 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(16);
const $81600ebf6aa664b1$var$_24 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(24);
const $81600ebf6aa664b1$var$_48 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $81600ebf6aa664b1$var$_48b = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(48);
const $81600ebf6aa664b1$var$_96 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$_192 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(192);
const $81600ebf6aa664b1$var$_384x = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_384y = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_384z = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(384);
const $81600ebf6aa664b1$var$_768 = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(768);
function $81600ebf6aa664b1$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, a, az, $81600ebf6aa664b1$var$_8), $81600ebf6aa664b1$var$_8, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, b, bz, $81600ebf6aa664b1$var$_8b), $81600ebf6aa664b1$var$_8b, (0, $b7be22ffc815751f$export$dcdf75081b88279d)(4, c, cz, $81600ebf6aa664b1$var$_8c), $81600ebf6aa664b1$var$_8c, $81600ebf6aa664b1$var$_16, out);
}
function $81600ebf6aa664b1$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)(alen, a, blen, b, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, (0, $b7be22ffc815751f$export$aef51622e549b8b0)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)(clen, c, dlen, d, $81600ebf6aa664b1$var$_48b), $81600ebf6aa664b1$var$_48b), $81600ebf6aa664b1$var$_48b, $81600ebf6aa664b1$var$_96);
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, x, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, x, $81600ebf6aa664b1$var$_384x), $81600ebf6aa664b1$var$_384x, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, y, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, y, $81600ebf6aa664b1$var$_384y), $81600ebf6aa664b1$var$_384y, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_96, z, $81600ebf6aa664b1$var$_192), $81600ebf6aa664b1$var$_192, z, $81600ebf6aa664b1$var$_384z), $81600ebf6aa664b1$var$_384z, $81600ebf6aa664b1$var$_768, out);
}
function $81600ebf6aa664b1$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $81600ebf6aa664b1$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$eb[3] = u3;
    const abclen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ac, cz, az, -bz, $81600ebf6aa664b1$var$abc);
    const bcdlen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$bd, dz, bz, -cz, $81600ebf6aa664b1$var$bcd);
    const cdelen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$ce, ez, cz, -dz, $81600ebf6aa664b1$var$cde);
    const dealen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$da, az, dz, -ez, $81600ebf6aa664b1$var$dea);
    const eablen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$eb, bz, ez, -az, $81600ebf6aa664b1$var$eab);
    const abdlen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bd, $81600ebf6aa664b1$var$da, dz, az, bz, $81600ebf6aa664b1$var$abd);
    const bcelen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ce, $81600ebf6aa664b1$var$eb, ez, bz, cz, $81600ebf6aa664b1$var$bce);
    const cdalen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ac, az, cz, dz, $81600ebf6aa664b1$var$cda);
    const deblen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$de, $81600ebf6aa664b1$var$eb, $81600ebf6aa664b1$var$bd, bz, dz, ez, $81600ebf6aa664b1$var$deb);
    const eaclen = $81600ebf6aa664b1$var$sum_three_scale($81600ebf6aa664b1$var$ea, $81600ebf6aa664b1$var$ac, $81600ebf6aa664b1$var$ce, cz, ez, az, $81600ebf6aa664b1$var$eac);
    const deterlen = (0, $b7be22ffc815751f$export$195a93e4bd4d876f)($81600ebf6aa664b1$var$liftexact(cdelen, $81600ebf6aa664b1$var$cde, bcelen, $81600ebf6aa664b1$var$bce, deblen, $81600ebf6aa664b1$var$deb, bcdlen, $81600ebf6aa664b1$var$bcd, ax, ay, az, $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet, $81600ebf6aa664b1$var$liftexact(dealen, $81600ebf6aa664b1$var$dea, cdalen, $81600ebf6aa664b1$var$cda, eaclen, $81600ebf6aa664b1$var$eac, cdelen, $81600ebf6aa664b1$var$cde, bx, by, bz, $81600ebf6aa664b1$var$bdet), $81600ebf6aa664b1$var$bdet, (0, $b7be22ffc815751f$export$195a93e4bd4d876f)($81600ebf6aa664b1$var$liftexact(eablen, $81600ebf6aa664b1$var$eab, deblen, $81600ebf6aa664b1$var$deb, abdlen, $81600ebf6aa664b1$var$abd, dealen, $81600ebf6aa664b1$var$dea, cx, cy, cz, $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet, $81600ebf6aa664b1$var$liftexact(abclen, $81600ebf6aa664b1$var$abc, eaclen, $81600ebf6aa664b1$var$eac, bcelen, $81600ebf6aa664b1$var$bce, eablen, $81600ebf6aa664b1$var$eab, dx, dy, dz, $81600ebf6aa664b1$var$ddet), $81600ebf6aa664b1$var$ddet, $81600ebf6aa664b1$var$liftexact(bcdlen, $81600ebf6aa664b1$var$bcd, abdlen, $81600ebf6aa664b1$var$abd, cdalen, $81600ebf6aa664b1$var$cda, abclen, $81600ebf6aa664b1$var$abc, ex, ey, ez, $81600ebf6aa664b1$var$edet), $81600ebf6aa664b1$var$edet, $81600ebf6aa664b1$var$cddet, $81600ebf6aa664b1$var$cdedet), $81600ebf6aa664b1$var$cdedet, $81600ebf6aa664b1$var$abdet, $81600ebf6aa664b1$var$deter);
    return $81600ebf6aa664b1$var$deter[deterlen - 1];
}
const $81600ebf6aa664b1$var$xdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$ydet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$zdet = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(96);
const $81600ebf6aa664b1$var$fin = (0, $b7be22ffc815751f$export$202e0172ed3c7be0)(1152);
function $81600ebf6aa664b1$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $81600ebf6aa664b1$var$sum_three_scale(a, b, c, az, bz, cz, $81600ebf6aa664b1$var$_24);
    return (0, $b7be22ffc815751f$export$195a93e4bd4d876f)((0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, x, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, x, $81600ebf6aa664b1$var$xdet), $81600ebf6aa664b1$var$xdet, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, y, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, y, $81600ebf6aa664b1$var$ydet), $81600ebf6aa664b1$var$ydet, (0, $b7be22ffc815751f$export$dcdf75081b88279d)((0, $b7be22ffc815751f$export$dcdf75081b88279d)(len, $81600ebf6aa664b1$var$_24, z, $81600ebf6aa664b1$var$_48), $81600ebf6aa664b1$var$_48, z, $81600ebf6aa664b1$var$zdet), $81600ebf6aa664b1$var$zdet, $81600ebf6aa664b1$var$_192, out);
}
function $81600ebf6aa664b1$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $81600ebf6aa664b1$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $81600ebf6aa664b1$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $81600ebf6aa664b1$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $81600ebf6aa664b1$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $81600ebf6aa664b1$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $b7be22ffc815751f$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $81600ebf6aa664b1$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $81600ebf6aa664b1$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $81600ebf6aa664b1$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $81600ebf6aa664b1$var$bd[3] = bd3;
    const finlen = (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$aef51622e549b8b0)($81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$bd, dez, bez, -cez, aex, aey, aez, $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet), $81600ebf6aa664b1$var$adet, $81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$cd, $81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ac, aez, cez, dez, bex, bey, bez, $81600ebf6aa664b1$var$bdet), $81600ebf6aa664b1$var$bdet, $81600ebf6aa664b1$var$abdet), $81600ebf6aa664b1$var$abdet, (0, $b7be22ffc815751f$export$8a63f25cc62965f1)((0, $b7be22ffc815751f$export$aef51622e549b8b0)($81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$da, $81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bd, bez, dez, aez, cex, cey, cez, $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet), $81600ebf6aa664b1$var$cdet, $81600ebf6aa664b1$var$liftadapt($81600ebf6aa664b1$var$ab, $81600ebf6aa664b1$var$bc, $81600ebf6aa664b1$var$ac, cez, aez, -bez, dex, dey, dez, $81600ebf6aa664b1$var$ddet), $81600ebf6aa664b1$var$ddet, $81600ebf6aa664b1$var$cddet), $81600ebf6aa664b1$var$cddet, $81600ebf6aa664b1$var$fin);
    let det = (0, $b7be22ffc815751f$export$9f3a0795ca2cc944)(finlen, $81600ebf6aa664b1$var$fin);
    let errbound = $81600ebf6aa664b1$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $81600ebf6aa664b1$var$isperrboundC * permanent + (0, $b7be22ffc815751f$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $81600ebf6aa664b1$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $81600ebf6aa664b1$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $81600ebf6aa664b1$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$81600ebf6aa664b1$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $81600ebf6aa664b1$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




function $488a266a48dd1b5c$export$2e2bcd8739ae039(p, polygon) {
    var i;
    var ii;
    var k = 0;
    var f;
    var u1;
    var v1;
    var u2;
    var v2;
    var currentP;
    var nextP;
    var x = p[0];
    var y = p[1];
    var numContours = polygon.length;
    for(i = 0; i < numContours; i++){
        ii = 0;
        var contour = polygon[i];
        var contourLen = contour.length - 1;
        currentP = contour[0];
        if (currentP[0] !== contour[contourLen][0] && currentP[1] !== contour[contourLen][1]) throw new Error("First and last coordinates in a ring must be the same");
        u1 = currentP[0] - x;
        v1 = currentP[1] - y;
        for(ii; ii < contourLen; ii++){
            nextP = contour[ii + 1];
            u2 = nextP[0] - x;
            v2 = nextP[1] - y;
            if (v1 === 0 && v2 === 0) {
                if (u2 <= 0 && u1 >= 0 || u1 <= 0 && u2 >= 0) return 0;
            } else if (v2 >= 0 && v1 <= 0 || v2 <= 0 && v1 >= 0) {
                f = (0, $a080ad2b3b4d3b31$export$bbb923599a46a7d8)(u1, u2, v1, v2, 0, 0);
                if (f === 0) return 0;
                if (f > 0 && v2 > 0 && v1 <= 0 || f < 0 && v2 <= 0 && v1 > 0) k++;
            }
            currentP = nextP;
            v1 = v2;
            u1 = u2;
        }
    }
    if (k % 2 === 0) return false;
    return true;
}



function $644c44cdb031b418$export$ae7424f794b3544b(point, polygon, options = {}) {
    if (!point) throw new Error("point is required");
    if (!polygon) throw new Error("polygon is required");
    const pt = (0, $9b195126e45e4c4e$export$b4663c6e64a770bc)(point);
    const geom = (0, $9b195126e45e4c4e$export$b8f320eb9549c8fd)(polygon);
    const type = geom.type;
    const bbox = polygon.bbox;
    let polys = geom.coordinates;
    if (bbox && $644c44cdb031b418$var$inBBox(pt, bbox) === false) return false;
    if (type === "Polygon") polys = [
        polys
    ];
    let result = false;
    for(var i = 0; i < polys.length; ++i){
        const polyResult = (0, $488a266a48dd1b5c$export$2e2bcd8739ae039)(pt, polys[i]);
        if (polyResult === 0) return options.ignoreBoundary ? false : true;
        else if (polyResult) result = true;
    }
    return result;
}
function $644c44cdb031b418$var$inBBox(pt, bbox) {
    return bbox[0] <= pt[0] && bbox[1] <= pt[1] && bbox[2] >= pt[0] && bbox[3] >= pt[1];
}
var $644c44cdb031b418$export$2e2bcd8739ae039 = $644c44cdb031b418$export$ae7424f794b3544b;



function $20c1bb73c4d4ca81$export$497c1ce5d547cfcd(geojson) {
    const fc = $20c1bb73c4d4ca81$var$normalize(geojson);
    const cent = (0, $4e1112713e478267$export$3481c78889e8fbe8)(fc);
    let onSurface = false;
    let i = 0;
    while(!onSurface && i < fc.features.length){
        const geom = fc.features[i].geometry;
        let x, y, x1, y1, x2, y2;
        let onLine = false;
        if (geom.type === "Point") {
            if (cent.geometry.coordinates[0] === geom.coordinates[0] && cent.geometry.coordinates[1] === geom.coordinates[1]) onSurface = true;
        } else if (geom.type === "MultiPoint") {
            let onMultiPoint = false;
            let k = 0;
            while(!onMultiPoint && k < geom.coordinates.length){
                if (cent.geometry.coordinates[0] === geom.coordinates[k][0] && cent.geometry.coordinates[1] === geom.coordinates[k][1]) {
                    onSurface = true;
                    onMultiPoint = true;
                }
                k++;
            }
        } else if (geom.type === "LineString") {
            let k = 0;
            while(!onLine && k < geom.coordinates.length - 1){
                x = cent.geometry.coordinates[0];
                y = cent.geometry.coordinates[1];
                x1 = geom.coordinates[k][0];
                y1 = geom.coordinates[k][1];
                x2 = geom.coordinates[k + 1][0];
                y2 = geom.coordinates[k + 1][1];
                if ($20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2)) {
                    onLine = true;
                    onSurface = true;
                }
                k++;
            }
        } else if (geom.type === "MultiLineString") {
            let j = 0;
            while(j < geom.coordinates.length){
                onLine = false;
                let k = 0;
                const line = geom.coordinates[j];
                while(!onLine && k < line.length - 1){
                    x = cent.geometry.coordinates[0];
                    y = cent.geometry.coordinates[1];
                    x1 = line[k][0];
                    y1 = line[k][1];
                    x2 = line[k + 1][0];
                    y2 = line[k + 1][1];
                    if ($20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2)) {
                        onLine = true;
                        onSurface = true;
                    }
                    k++;
                }
                j++;
            }
        } else if (geom.type === "Polygon" || geom.type === "MultiPolygon") {
            if ((0, $644c44cdb031b418$export$ae7424f794b3544b)(cent, geom)) onSurface = true;
        }
        i++;
    }
    if (onSurface) return cent;
    else {
        const vertices = (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([]);
        for(let f = 0; f < fc.features.length; f++)vertices.features = vertices.features.concat((0, $40b1a25d9324c658$export$7b82f38e9ee2ae8)(fc.features[f]).features);
        return (0, $99d87cb8abf11eaa$export$105684a3041cb6f3)((0, $cdae9ad4d14de8da$export$ba330bb14d26e4ac)(cent, vertices).geometry.coordinates);
    }
}
function $20c1bb73c4d4ca81$var$normalize(geojson) {
    if (geojson.type !== "FeatureCollection") {
        if (geojson.type !== "Feature") return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([
            (0, $99d87cb8abf11eaa$export$ced6ed16dfd6a264)(geojson)
        ]);
        return (0, $99d87cb8abf11eaa$export$4717c67ac3e5e04d)([
            geojson
        ]);
    }
    return geojson;
}
function $20c1bb73c4d4ca81$var$pointOnSegment(x, y, x1, y1, x2, y2) {
    const ab = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    const ap = Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
    const pb = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
    return ab === ap + pb;
}
var $20c1bb73c4d4ca81$export$2e2bcd8739ae039 = $20c1bb73c4d4ca81$export$497c1ce5d547cfcd;


const $bee92962b46fc3f3$var$woosmapPublicKey = "woos-a10037a3-3f08-311e-af1d-2eb8b922749a";
const $bee92962b46fc3f3$var$libraries = "widgets";
const $bee92962b46fc3f3$var$env = "prod";
const $bee92962b46fc3f3$var$eventYear = "2025";
const $bee92962b46fc3f3$var$mapOptions = {
    center: {
        lat: 49,
        lng: 9
    },
    zoom: 18,
    styles: [
        {
            featureType: "all",
            stylers: [
                {
                    "saturation": -100
                }
            ]
        }
    ]
};
const $bee92962b46fc3f3$var$mobileBreakPoint = 768;
const $bee92962b46fc3f3$var$bucket = $bee92962b46fc3f3$var$env === "prod" ? "" : "-stage";
const $bee92962b46fc3f3$var$indoorRendererOptions = {
    centerMap: false,
    theme: `sdm_default_${$bee92962b46fc3f3$var$eventYear}`,
    venue: $bee92962b46fc3f3$var$env === "prod" ? `SDM_${$bee92962b46fc3f3$var$eventYear}` : `sdm_${$bee92962b46fc3f3$var$eventYear}_dev`,
    forceExtrusion: false,
    useInfoWindow: true,
    snapToVenueBounds: true,
    directionsIcons: {
        destinationIcon: {
            url: `https://indoor.woosmap.com/salone-del-mobile${$bee92962b46fc3f3$var$bucket}/assets/location_on.png`,
            scaledSize: {
                height: 40,
                width: 40
            },
            anchor: {
                x: 20,
                y: 38
            }
        },
        originIcon: {
            url: `https://indoor.woosmap.com/salone-del-mobile${$bee92962b46fc3f3$var$bucket}/assets/trip_origin.png?v=1`,
            scaledSize: {
                height: 30,
                width: 30
            },
            anchor: {
                x: 15,
                y: 15
            }
        }
    },
    polylineOptions: {
        color: "#00158F",
        strokeColor: "#00158F",
        highlightColor: "#00D9FF"
    }
};
const $bee92962b46fc3f3$var$widgetOptions = {
    // autocompleteWithDistance: true,
    ui: {
        primaryColor: "rgb(0 0 0 / 80%)",
        secondaryColor: "#e30613"
    },
    autocomplete: {
        maxResponses: 10,
        autocompleteWithDistance: false,
        baseFilter: ""
    }
};
const $bee92962b46fc3f3$var$GATag = $bee92962b46fc3f3$var$env === "prod" ? "GTM-WJM8VDL2" : "GTM-MQ2P2JCK";
const $bee92962b46fc3f3$var$themes = {
    default: `sdm_default_${$bee92962b46fc3f3$var$eventYear}`,
    favorites: "favorites"
};
var $bee92962b46fc3f3$export$2e2bcd8739ae039 = {
    mapOptions: $bee92962b46fc3f3$var$mapOptions,
    indoorRendererOptions: $bee92962b46fc3f3$var$indoorRendererOptions,
    indoorWidgetOptions: $bee92962b46fc3f3$var$widgetOptions,
    woosmapPublicKey: $bee92962b46fc3f3$var$woosmapPublicKey,
    libraries: $bee92962b46fc3f3$var$libraries,
    query: "",
    GATag: $bee92962b46fc3f3$var$GATag,
    env: $bee92962b46fc3f3$var$env,
    themes: $bee92962b46fc3f3$var$themes,
    mobileBreakPoint: $bee92962b46fc3f3$var$mobileBreakPoint,
    eventYear: $bee92962b46fc3f3$var$eventYear
};




const $ec948a4cf72a2ce9$export$f84bd70098573c5c = {
    map: (0, $bee92962b46fc3f3$export$2e2bcd8739ae039),
    urls: (0, $20654a4b7519d360$export$2e2bcd8739ae039)
};
let $ec948a4cf72a2ce9$var$currentConfig = $ec948a4cf72a2ce9$export$f84bd70098573c5c;
function $ec948a4cf72a2ce9$export$29b4b847eef7ae1e(configObj) {
    const config = configObj || {};
    return (0, $ee9cb80b5c23ac97$export$4950aa0f605343fb)({
        ...config
    }, {
        ...$ec948a4cf72a2ce9$var$currentConfig
    });
}
function $ec948a4cf72a2ce9$export$940a7873bb071df8(configObj) {
    $ec948a4cf72a2ce9$var$currentConfig = $ec948a4cf72a2ce9$export$29b4b847eef7ae1e(configObj);
}
function $ec948a4cf72a2ce9$export$44487a86467333c3() {
    return $ec948a4cf72a2ce9$var$currentConfig;
}


function $ee9cb80b5c23ac97$export$89a7e74069fbb7af(params = {}) {
    let queryString = "";
    Object.keys(params).forEach((key)=>{
        if (queryString.length !== 0) queryString += "&";
        queryString += key + "=" + params[key].toString();
    });
    return queryString;
}
function $ee9cb80b5c23ac97$export$b89605802fcf91d2(polylineString, precision = 5) {
    const coordinates = [];
    const factor = Math.pow(10, precision);
    let index, lat, lng, byte, shift, result, latitude_change, longitude_change;
    index = 0;
    lat = 0;
    lng = 0;
    while(index < polylineString.length){
        byte = null;
        shift = 0;
        result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        shift = result = 0;
        do {
            byte = polylineString.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
}
function $ee9cb80b5c23ac97$export$61fc7d43ac8f84b0(callback, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            callback(...args);
        }, timeout);
    };
}
function $ee9cb80b5c23ac97$export$37827d046293d309(text) {
    const canvas = document.getElementById("canvasMarkerWoosmap") || document.createElement("canvas");
    canvas.id = "canvasMarkerWoosmap";
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.font = "bold 15px sans-serif";
    return context.measureText(text).width;
}
function $ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input);
}
function $ee9cb80b5c23ac97$export$4950aa0f605343fb(target, source) {
    if (!$ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(source) || !$ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(target)) return target;
    for(const key in source){
        const targetProp = target[key];
        const sourceProp = source[key];
        if ($ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(sourceProp) && $ee9cb80b5c23ac97$export$a6cdc56e425d0d0a(targetProp)) $ee9cb80b5c23ac97$export$4950aa0f605343fb(targetProp, sourceProp);
        else if (!(key in target)) target[key] = source[key];
    }
    return target;
}
function $ee9cb80b5c23ac97$export$77ad94ebf1c2b9ed(str, keyValues) {
    let result = str;
    Object.keys(keyValues).forEach((key)=>{
        result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), keyValues[key]);
    });
    return result;
}
function $ee9cb80b5c23ac97$export$f73bf9563a5df5ec(theme) {
    if (theme && (theme !== "sdm_default" || "")) {
        const jsonData = (0, $1b81979ac4ba0c49$export$2e2bcd8739ae039)["thematics"];
        const filteredTheme = Array.from(jsonData).filter((element)=>{
            return element.ref.toLowerCase() === theme.toLowerCase();
        });
        if (filteredTheme[0]) filteredTheme[0] = {
            ...filteredTheme[0],
            title: (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme.toLowerCase()),
            description: (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematicDescription, theme.toLowerCase())
        };
        return filteredTheme[0];
    }
}
function $ee9cb80b5c23ac97$export$c6d77cdc3b11bbfd(pav) {
    if (pav && pav !== "") {
        const jsonData = (0, $03005ecb18aee849$export$2e2bcd8739ae039)["buildings"];
        const filteredResult = Array.from(jsonData).filter((element)=>{
            return element.ref.toLowerCase() === pav.toLowerCase();
        });
        return filteredResult[0];
    }
}
function $ee9cb80b5c23ac97$export$53fc19a32de59f94(feature) {
    let position = {
        lat: 0,
        lng: 0
    };
    if (feature && feature.geometry && feature.geometry.type === "Polygon") {
        const center = (0, $20c1bb73c4d4ca81$export$497c1ce5d547cfcd)(feature);
        position = {
            lat: center.geometry.coordinates[1],
            lng: center.geometry.coordinates[0]
        };
    } else if (feature && feature.geometry && feature.geometry.type === "Point") position = {
        lat: feature.geometry.coordinates[1],
        lng: feature.geometry.coordinates[0]
    };
    return position;
}
function $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17(message, type) {
    const container = document.getElementById("woos-toast-container");
    if (!container) return;
    const existingToast = container.querySelector(`.woos-toast.${type}`);
    if (existingToast) return;
    const toast = document.createElement("div");
    toast.className = `woos-toast ${type}`;
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(()=>{
        toast.remove();
    }, 4500);
}
function $ee9cb80b5c23ac97$export$7d9f9b4046392aed() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width < (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mobileBreakPoint) return true;
    return false;
}
function $ee9cb80b5c23ac97$export$3ba45bd218cae310(isMobile = false) {
    const defaultPadding = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    };
    let panelHeight = 0;
    let panelWidth = 0;
    const headerContent = document.getElementsByClassName("woosmap-panel__content__header")[0];
    const bodyContent = document.getElementsByClassName("woosmap-panel__content__body")[0];
    const searchBarContainer = document.getElementsByClassName("woosmap-panel__header")[0];
    if (searchBarContainer && headerContent && bodyContent) {
        panelHeight = headerContent.clientHeight + bodyContent.clientHeight + searchBarContainer.clientHeight;
        panelWidth = searchBarContainer.clientWidth;
    }
    panelHeight = isMobile ? 0 : panelHeight;
    if ($ee9cb80b5c23ac97$export$7d9f9b4046392aed()) defaultPadding.bottom = panelHeight;
    else defaultPadding.left = panelWidth;
    return defaultPadding;
}



/**
 * Previously loading/loaded scripts that have been requested by `loadScript()`.
 */ let $109f615c63b90aba$var$cachedScripts = {};
function $109f615c63b90aba$export$2cb99e4be0dc4646(options) {
    const { url: url, params: params, override: override, callback: callback } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    const existing = $109f615c63b90aba$var$cachedScripts[src];
    if (existing) {
        if (override) {
            const script = $109f615c63b90aba$var$getScriptElement(src);
            if (script) {
                delete $109f615c63b90aba$var$cachedScripts[src];
                script.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($109f615c63b90aba$var$findScript(src)) resolve();
        const script = $109f615c63b90aba$export$28503efd90ff36be(url, params);
        const dependencyScriptSrc = (0, $20654a4b7519d360$export$2e2bcd8739ae039).widgetJS;
        const loadDependency = (dependencySrc)=>{
            return new Promise((dependencyResolve, dependencyReject)=>{
                const dependencyScript = $109f615c63b90aba$export$28503efd90ff36be(dependencySrc);
                const onDependencyScriptLoad = ()=>{
                    dependencyScript.removeEventListener("load", onDependencyScriptLoad);
                    dependencyScript.removeEventListener("error", onDependencyScriptError);
                    dependencyResolve();
                };
                const onDependencyScriptError = ()=>{
                    cleanup();
                    delete $109f615c63b90aba$var$cachedScripts[dependencySrc];
                    dependencyScript.remove();
                    const dependencyError = new Error(`The dependency script "${dependencySrc}" failed to load.`);
                    dependencyReject(dependencyError);
                };
                dependencyScript.addEventListener("load", onDependencyScriptLoad);
                dependencyScript.addEventListener("error", onDependencyScriptError);
                document.body.insertBefore(dependencyScript, document.body.lastElementChild);
            });
        };
        const onScriptLoad = ()=>{
            cleanup();
            loadDependency(dependencyScriptSrc).then(()=>{
                if (callback) callback(); // Execute the callback after script and dependencies have loaded
                resolve();
            }).catch((dependencyError)=>{
                reject(dependencyError);
            });
        };
        const onScriptError = ()=>{
            cleanup();
            delete $109f615c63b90aba$var$cachedScripts[src];
            script.remove();
            const defaultError = new Error(`The script "${src}" failed to load.`);
            reject(defaultError);
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        document.body.insertBefore(script, document.body.lastElementChild);
        function cleanup() {
            script.removeEventListener("load", onScriptLoad);
            script.removeEventListener("error", onScriptError);
        }
    });
    $109f615c63b90aba$var$cachedScripts[src] = promise;
    return promise;
}
/**
 * Find script src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {boolean | null} returns `true` if script exist otherwise `null`.
 */ function $109f615c63b90aba$var$findScript(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return true;
}
/**
 * Get script by src in the DOM
 * @param {string} src - used to set the script url and attributes.
 * @return {HTMLScriptElement | null} returns existing `HTMLScriptElement` if script exist otherwise `null`.
 */ function $109f615c63b90aba$var$getScriptElement(src) {
    const currentScript = document.querySelector(`script[src="${src}"]`);
    if (currentScript === null) return null;
    return currentScript;
}
function $109f615c63b90aba$export$28503efd90ff36be(url, params = {}) {
    const newScript = document.createElement("script");
    newScript.src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    newScript.async = true;
    newScript.defer = true;
    return newScript;
}
function $109f615c63b90aba$export$41a88579f6bd1282() {
    $109f615c63b90aba$var$cachedScripts = {};
}





var $0f8c890e7395704d$export$715fed9478e7c158;
(function(MapComponentEvents) {
    MapComponentEvents["MAP_READY"] = "map_ready";
    MapComponentEvents["MAP_IDLE"] = "idle";
    MapComponentEvents["INDOOR_VENUE_LOADED"] = "indoor_venue_loaded";
    MapComponentEvents["INDOOR_WIDGET_ANALYTICS"] = "indoor_widget_analytics";
    MapComponentEvents["INDOOR_POI_ON_MAP_CLICK"] = "indoor_feature_selected";
    MapComponentEvents["INDOOR_HIGHLIGHT_STEP"] = "indoor_highlight_step";
    MapComponentEvents["INDOOR_STOP_NAVIGATION"] = "indoor_stop_navigation";
    MapComponentEvents["INDOOR_LEVEL_CHANGED"] = "indoor_level_changed";
    MapComponentEvents["FAVORITE_MARKER_CLICKED"] = "fav_marker_clicked";
})($0f8c890e7395704d$export$715fed9478e7c158 || ($0f8c890e7395704d$export$715fed9478e7c158 = {}));
class $0f8c890e7395704d$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.$element = document.createElement("div");
        this.$element.id = "map";
        this.$target.appendChild(this.$element);
    }
    render() {
        if (this.state && this.$element) (0, $109f615c63b90aba$export$2cb99e4be0dc4646)({
            url: (0, $20654a4b7519d360$export$2e2bcd8739ae039).mapJS,
            params: {
                key: this.state.woosmapPublicKey,
                libraries: this.state.libraries,
                language: (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()
            },
            override: true,
            callback: ()=>{
                this.initMapView();
            }
        }).then(()=>{
            // this.initMapView();
            console.log("Scripts loaded...");
        }).catch((error)=>{
            console.error((0, $ee9cb80b5c23ac97$export$77ad94ebf1c2b9ed)((0, $58070e9281bc680d$export$180605366c04f0cd)().errors.loadingLibrary, {
                "library": "Woosmap Map JS SDK script"
            }), error);
        });
    }
    initMapView() {
        this.map = new woosmap.map.Map("map", Object.assign({}, this.state.mapOptions));
        this.emit("map_ready");
        this.map.addListener("idle", ()=>{
            this.emit("idle");
        });
        this.map.addListener("rightclick", (e)=>{
            console.log(e);
        });
    }
    initIndoorView() {
        const widgetOptions = this.state.query && this.state.query !== `thematic:=${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorWidgetOptions,
            baseFilter: this.state.query
        } : this.state.indoorWidgetOptions;
        const rendererOptions = this.state.query && this.state.query !== `thematic:=${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.theme}` ? {
            ...this.state.indoorRendererOptions,
            baseFilter: this.state.query
        } : this.state.indoorRendererOptions;
        this.indoorMap = new woosmap.map.IndoorWidget(widgetOptions, rendererOptions);
        this.indoorMap.setMap(this.map);
        this.indoorMap.addListener("indoor_venue_loaded", (venue)=>{
            this.currentLevel = 0;
            this.emit("indoor_venue_loaded", venue);
        });
        this.indoorMap.addListener("indoor_widget_analytics", (event)=>{
            this.emit("indoor_widget_analytics", event);
        });
        this.indoorMap.addListener("indoor_feature_selected", (event)=>{
            this.emit("indoor_feature_selected", event);
        });
        this.indoorMap.addListener("indoor_highlight_step", (event)=>{
            this.emit("indoor_highlight_step", event);
        });
        this.indoorMap.addListener("indoor_stop_navigation", (event)=>{
            this.emit("indoor_stop_navigation", event);
        });
        this.indoorMap.addListener("indoor_level_changed", (event)=>{
            this.currentLevel = event;
            if (this.userFavorites) this.plotUserFavoritesOnMap(this.userFavorites);
        });
    }
    setFilter(filter) {
        const filterToApply = filter !== undefined ? `thematic:=${filter} OR ${filter}:=true` : ``;
        if (filter !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && filter !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) {
            this.indoorMap.getRenderer().setBaseFilter(filterToApply);
            this.indoorMap.setBaseFilter(filterToApply);
        } else {
            this.indoorMap.getRenderer().setBaseFilter("");
            this.indoorMap.setBaseFilter("");
        }
    }
    setOrigin(data) {
        this.indoorMap.setUserLocation(data.lat, data.lng, data.level || 0, 0, true);
    }
    setTheme(theme) {
        const themeToApply = theme !== undefined ? theme : (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"];
        if (this.indoorMap) this.indoorMap.setTheme(themeToApply);
    }
    setBounds(bounds) {
        let padding = {
            top: 0,
            left: 150,
            right: 150,
            bottom: 0
        };
        if (this.$element.clientWidth > 768) padding = {
            top: 350,
            left: 350,
            right: 350,
            bottom: 350
        };
        this.map.fitBounds(bounds, padding, true);
    }
    unselectPOI() {
        this.indoorMap.unselectFeature();
    }
    turnOffNavigation() {
        this.indoorMap.setNavigationMode(false);
    }
    getDirections() {
        return this.indoorMap.getRenderer()._directionsRenderer.directions;
    }
    showRouteForAllLevels() {
        if (this.indoorMap) {
            const mapStyle = this.map._style;
            if (mapStyle) mapStyle.addLayer({
                id: "indoor-directions-all-levels",
                type: "line",
                source: "indoor-directions",
                filter: [
                    "all",
                    [
                        "==",
                        [
                            "get",
                            "enabled"
                        ],
                        false
                    ]
                ],
                layout: {
                    "line-join": "round",
                    "line-cap": "round"
                },
                paint: {
                    "line-color": "#808AC7",
                    "line-opacity": 0.8,
                    "line-width": 6
                }
            }, "indoor-directions_layers");
        }
    }
    showRouteForSponsor(origin, destination) {
        const originPoint = `${origin.lat},${origin.lng},0`;
        const indoorService = new woosmap.map.IndoorService();
        const cbSearch = (result)=>{
            if (result && result.features && result.features.length > 0) {
                const feature = result.features[0];
                this.indoorMap.showItinerary(originPoint, feature);
            }
        };
        // TO DO REFACTOR : Awaiting data from client to get sponsored logos and defining final structure.
        indoorService.search((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.venue || `sdm_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.env}`, "", cbSearch, destination);
    }
    plotUserFavoritesOnMap(favorites) {
        console.log("Inside plotUserFavoritesOnMap....", favorites);
        this.removeMarkersForFavs();
        this.userFavorites = favorites;
        this.favMarkers = [];
        for (const fav of favorites)if (parseInt(fav.properties.level) === this.currentLevel) {
            const marker = new woosmap.map.Marker({
                position: (0, $ee9cb80b5c23ac97$export$53fc19a32de59f94)(fav),
                icon: {
                    url: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.favMarkerUrl,
                    scaledSize: {
                        height: 28,
                        width: 28
                    }
                }
            });
            marker.addListener("click", ()=>{
                this.indoorMap.highlightFeature(fav.id, false);
                this.emit("fav_marker_clicked", fav);
            });
            this.favMarkers.push(marker);
            marker.setMap(this.map);
        }
    }
    removeMarkersForFavs() {
        if (this.favMarkers) {
            this.favMarkers.forEach((marker)=>{
                marker.setMap(null);
            });
            this.favMarkers = [];
            this.userFavorites = [];
        }
    }
    destroyMap() {
        if (this.indoorMap) {
            this.indoorMap.getRenderer().setMap(null);
            this.indoorMap = null;
            this.map = new woosmap.map.Map("map", Object.assign({}, this.state.mapOptions));
            this.initIndoorView();
        }
    }
}





/**
 * Previously preloaded links that have been requested by `preloadLink()`.
 */ let $9bbb064cf4ce4d36$var$preloadedLinks = {};
function $9bbb064cf4ce4d36$export$a0db4953bb08f589(options) {
    const { url: url, params: params, as: as, crossOrigin: crossOrigin, override: override } = options;
    if (!url || url.length === 0) throw new Error("Invalid url.");
    if (typeof params !== "undefined" && typeof params !== "object") throw new Error("Expected params to be an object.");
    const src = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    const existing = $9bbb064cf4ce4d36$var$preloadedLinks[src];
    if (existing) {
        if (override) {
            const link = $9bbb064cf4ce4d36$var$getLinkElement(src);
            if (link) {
                delete $9bbb064cf4ce4d36$var$preloadedLinks[src];
                link.remove();
            }
        } else return existing;
    }
    const promise = new Promise((resolve, reject)=>{
        if ($9bbb064cf4ce4d36$var$findLink(src)) resolve();
        const link = $9bbb064cf4ce4d36$export$b756667c7b6cccbc(url, params, as, crossOrigin);
        const onLinkLoad = ()=>{
            resolve();
        };
        const onLinkError = ()=>{
            cleanup();
            delete $9bbb064cf4ce4d36$var$preloadedLinks[src];
            link.remove();
            const defaultError = new Error(`The link "${src}" failed to preload.`);
            reject(defaultError);
        };
        link.addEventListener("load", onLinkLoad);
        link.addEventListener("error", onLinkError);
        document.head.insertBefore(link, document.head.firstElementChild);
        function cleanup() {
            link.removeEventListener("load", onLinkLoad);
            link.removeEventListener("error", onLinkError);
        }
    });
    $9bbb064cf4ce4d36$var$preloadedLinks[src] = promise;
    return promise;
}
/**
 * Find link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {boolean | null} returns `true` if link exist otherwise `null`.
 */ function $9bbb064cf4ce4d36$var$findLink(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return true;
}
/**
 * Get link preload by src in the DOM
 * @param {string} src - used to set the link url and attributes.
 * @return {HTMLLinkElement | null} returns existing `HTMLLinkElement` if link exist otherwise `null`.
 */ function $9bbb064cf4ce4d36$var$getLinkElement(src) {
    const currentLink = document.querySelector(`link[rel="preload"][href^="${src}"]`);
    if (currentLink === null) return null;
    return currentLink;
}
function $9bbb064cf4ce4d36$export$b756667c7b6cccbc(url, params = {}, as, crossOrigin, type) {
    const newLink = document.createElement("link");
    if (Object.keys(params).length) newLink.href = `${url}?${(0, $ee9cb80b5c23ac97$export$89a7e74069fbb7af)(params)}`;
    else newLink.href = `${url}`;
    if (crossOrigin) newLink.crossOrigin = crossOrigin;
    if (type) newLink.type = type;
    newLink.rel = "preload";
    newLink.as = as;
    return newLink;
}
function $9bbb064cf4ce4d36$export$f427c08ae26d1d06() {
    $9bbb064cf4ce4d36$var$preloadedLinks = {};
}









var $3c0730fc6dc90d7f$export$834029a0b90ac2e7;
(function(ThematicComponentEvents) {
    ThematicComponentEvents["THEMATIC_SELECTED"] = "thematic_selected";
    ThematicComponentEvents["LANGUAGE_CHANGED"] = "language_changed";
    ThematicComponentEvents["BUILDING_SELECTED"] = "building_selected";
    ThematicComponentEvents["ALL_EXHIBITS_SELECTED"] = "all_exhibits_selected";
    ThematicComponentEvents["FAVORITES_SELECTED"] = "favorites";
    ThematicComponentEvents["THEMATIC_UNSELECTED"] = "thematic_unselected";
})($3c0730fc6dc90d7f$export$834029a0b90ac2e7 || ($3c0730fc6dc90d7f$export$834029a0b90ac2e7 = {}));
class $3c0730fc6dc90d7f$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.renderThematics();
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        if ($btnAllExhibits) {
            $btnAllExhibits.textContent = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits;
            $btnAllExhibits.addEventListener("click", ()=>{
                this.switchMap("all");
            });
        }
        if ($btnFavorites) {
            $btnFavorites.textContent = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites;
            $btnFavorites.addEventListener("click", ()=>{
                $btnFavorites.classList.add("active");
                this.switchMap("favorites");
            });
        }
        this.renderBuildings(this.defaultTheme && this.defaultTheme.ref);
    }
    render() {}
    renderThematics() {
        const jsonData = (0, $1b81979ac4ba0c49$export$2e2bcd8739ae039)["thematics"];
        const container = document.getElementById("thematicDropdown");
        const chooseTitle = document.getElementsByClassName("thematic-selector-title");
        const $btnThematic = document.getElementById("btnThematic");
        if (chooseTitle && chooseTitle[0]) chooseTitle[0].innerHTML = (0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.choose_thematic;
        if ($btnThematic) $btnThematic.innerHTML = `${(0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)() ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
        if (container) {
            container.innerHTML = "";
            jsonData.forEach((item)=>{
                const $dropdownElem = document.createElement("a");
                $dropdownElem.tabIndex = 1;
                $dropdownElem.setAttribute("data-id", item["ref"].toString());
                const ref = item["ref"];
                $dropdownElem.textContent = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, ref);
                if (this.state.query && this.state.query !== "" && this.state.query.includes("thematic")) {
                    const selectedTheme = this.state.query?.split("=")[1] || "";
                    if (selectedTheme.toLowerCase() === ref.toLowerCase()) this.defaultTheme = item;
                }
                $dropdownElem.onclick = ()=>{
                    this.resetClasses();
                    const filter = `thematic:=${item["ref"].replace(" ", "").toLowerCase()}`;
                    this.emit("thematic_selected", filter);
                    this.renderBuildings(item["ref"].replace(" ", "").toLowerCase());
                    if ($btnThematic) {
                        $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, ref)} <span class="caret"></span>`;
                        $btnThematic.classList.add("active");
                    }
                    container.querySelectorAll("a").forEach((option)=>{
                        option.classList.remove("selected-thematic");
                        option.classList.add("unselected-thematic");
                    });
                    $dropdownElem.classList.remove("unselected-thematic");
                    $dropdownElem.classList.add("selected-thematic");
                };
                container.appendChild($dropdownElem);
            });
        } else console.error("Container not found");
        if (this.defaultTheme) this.setThematicOnLoad(this.defaultTheme);
    }
    renderBuildings(theme) {
        const jsonData = (0, $03005ecb18aee849$export$2e2bcd8739ae039)["buildings"];
        const container = document.getElementById("pavilion-slide");
        if (container) {
            container.innerHTML = "";
            jsonData.forEach((item)=>{
                if (theme) {
                    if (item.thematics?.includes(theme)) this.renderPavHTML(item, container);
                } else this.renderPavHTML(item, container);
            });
        }
    }
    renderPavHTML(item, container) {
        const $sliderElement = document.createElement("div");
        const span = document.createElement("span");
        $sliderElement.tabIndex = 1;
        $sliderElement.setAttribute("data-id", item["ref"].toString());
        $sliderElement.setAttribute("class", "slide");
        span.textContent = item.title;
        $sliderElement.onclick = ()=>{
            if ($sliderElement.classList.contains("slide")) {
                const slides = document.querySelectorAll("#pavilion-slide .slide");
                if ($sliderElement.classList.contains("clicked")) {
                    $sliderElement.classList.remove("clicked");
                    this.selectedBuilding = undefined;
                    this.emit("building_selected", undefined);
                } else {
                    slides.forEach((slide)=>{
                        slide.classList.remove("clicked");
                    });
                    $sliderElement.classList.add("clicked");
                    this.selectedBuilding = item;
                    this.emit("building_selected", item);
                }
            }
        };
        $sliderElement.appendChild(span);
        container.appendChild($sliderElement);
    }
    selectThematic(theme) {
        const $divElements = document.querySelectorAll(".slide");
        const filteredDivs = Array.from($divElements).filter((element)=>{
            const spanElement = element.querySelector("span");
            const textToMatch = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase());
            return spanElement && spanElement.textContent?.toLowerCase() === textToMatch.toLowerCase();
        });
        filteredDivs.forEach((div)=>{
            div.classList.toggle("clicked");
        });
        const $thematicsDescription = document.getElementById("thematicDescription");
        if ($thematicsDescription && this.state.showDescription) $thematicsDescription.innerHTML = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematicDescription, theme["ref"].toLowerCase()) || theme["description"] || "";
        this.emit("thematic_selected", `thematic:=${theme["ref"].toLowerCase()}`);
    }
    switchMap(mode) {
        this.resetClasses();
        this.defaultTheme = null;
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        switch(mode){
            case "all":
                $btnAllExhibits.classList.add("active");
                this.renderBuildings();
                this.emit("thematic_unselected", (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"]);
                break;
            case "favorites":
                $btnFavorites.classList.add("active");
                this.renderBuildings();
                this.emit("thematic_unselected", (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]);
                break;
        }
    }
    resetClasses() {
        const $btnThematic = document.getElementById("btnThematic");
        const container = document.getElementById("thematicDropdown");
        $btnThematic.classList.remove("active");
        $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        if ($btnAllExhibits) $btnAllExhibits.classList.remove("active");
        if ($btnFavorites) $btnFavorites.classList.remove("active");
        if (container) container.querySelectorAll("a").forEach((option)=>{
            option.classList.remove("selected-thematic");
        });
    }
    setThematicOnLoad(theme) {
        const container = document.getElementById("thematicDropdown");
        const $btnThematic = document.getElementById("btnThematic");
        if (container) {
            container.querySelectorAll("a").forEach((option)=>{
                option.classList.remove("selected-thematic");
            });
            Array.from(container.querySelectorAll("a")).forEach((element)=>{
                const textToMatch = (0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase());
                if (element && element.textContent?.toLowerCase() === textToMatch.toLowerCase()) element.classList.add("selected-thematic");
            });
        }
        if ($btnThematic) {
            $btnThematic.innerHTML = `${(0, $58070e9281bc680d$export$236350842f3cd9bc)((0, $58070e9281bc680d$export$180605366c04f0cd)().thematics, theme["ref"].toLowerCase())} <span class="caret-white"></span>`;
            $btnThematic.classList.add("active");
        }
        this.emit("thematic_selected", `thematic:=${theme["ref"].toLowerCase()}`);
    }
    setCTAText(isMobileView) {
        const $btnAllExhibits = document.getElementById("btnAllExhibits");
        const $btnFavorites = document.getElementById("btnFavorites");
        const $btnThematic = document.getElementById("btnThematic");
        if ($btnAllExhibits) $btnAllExhibits.textContent = isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.allexhibits;
        if ($btnFavorites) $btnFavorites.textContent = isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.favorites;
        if ($btnThematic) $btnThematic.innerHTML = `${isMobileView ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic_mobile : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.select_thematic} <span class="caret"></span>`;
    }
}





var $67dc1e3ffb36eb73$export$e163f07d771b24a3;
(function(KioskComponentEvents) {
    KioskComponentEvents["LOGO_CLICKED"] = "logo_clicked";
    KioskComponentEvents["LOGOS_LOADED"] = "logos_loaded";
    KioskComponentEvents["LANGUAGE_CHANGED"] = "language_changed";
    KioskComponentEvents["MAP_RELOAD"] = "map_reload";
})($67dc1e3ffb36eb73$export$e163f07d771b24a3 || ($67dc1e3ffb36eb73$export$e163f07d771b24a3 = {}));
class $67dc1e3ffb36eb73$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {
        this.sessionDuration = 60;
        this.updateSessionCountdown = this.updateSessionCountdown.bind(this);
        this.getSponsoredLogos().then((response)=>{
            const sponsorsData = response.features;
            this.shuffleSponsorsArray(sponsorsData);
            this.marqueeRows = [
                [],
                [],
                [],
                []
            ];
            sponsorsData.forEach((img, index)=>{
                this.marqueeRows[index % 4].push(img);
            });
            this.renderSponsors();
        });
        const $languageSelector = document.getElementById("languageSelector");
        if ($languageSelector) $languageSelector.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.selectLanguage;
        const $rightContainer = document.querySelector(".right-buttons");
        if ($rightContainer) {
            const $linkReset = document.createElement("a");
            $linkReset.id = "lnkReset";
            $linkReset.href = "#";
            $linkReset.innerText = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.resetMap;
            $linkReset.style.visibility = "hidden";
            $linkReset.style.color = "#e30613";
            $linkReset.addEventListener("click", (event)=>{
                event.preventDefault();
                this.resetMap();
            });
            $rightContainer.appendChild($linkReset);
        }
        this.initializeLanguageSelector();
    }
    render() {}
    renderSponsors() {
        this.removeExistingMarquees();
        for(let i = 0; i < 4; i++)this.createMarquee(i);
        requestAnimationFrame(()=>{
            this.restartMarqueeAnimation(".marquee");
        });
    }
    createMarquee(rowIndex) {
        const marquee = document.querySelector(`#marquee-container-${rowIndex + 1} .marquee`);
        const marqueeContent = document.createElement("div");
        marqueeContent.classList.add("marquee-content");
        if (marquee) {
            this.marqueeRows[rowIndex].forEach((sponsor)=>{
                const img = document.createElement("img");
                img.src = sponsor.properties.Sponsored_URL;
                img.onerror = ()=>{
                    console.error(`Failed to load image: ${sponsor.properties.name}`);
                    img.style.display = "none"; // Hide the broken image
                };
                img.dataset.ref = sponsor.properties.ref;
                marqueeContent.appendChild(img);
            });
            marquee.addEventListener("click", (e)=>{
                const target = e.target;
                if (target.tagName === "IMG" && target.dataset.ref) {
                    this.startSessionCountdown();
                    this.emit("logo_clicked", target.dataset.ref);
                }
            });
            const marqueeClone = marqueeContent.cloneNode(true);
            marquee.appendChild(marqueeContent);
            marquee.appendChild(marqueeClone);
        }
    }
    shuffleSponsorsArray(array) {
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [
                array[j],
                array[i]
            ];
        }
    }
    getSponsoredLogos() {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            const cbSponsoredLogos = (response)=>{
                if (response && response.features && response.features.length > 0) {
                    this.allSponsors = response.features;
                    resolve(response);
                } else reject(new Error("No sponsors found."));
            };
            indoorService.search((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions.venue || `sdm_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.env}`, "", cbSponsoredLogos, null, null, `Is_Sponsored:="yes"`);
        });
    }
    initializeLanguageSelector() {
        const languageSelector = document.querySelector(".sl-nav");
        if (languageSelector) {
            const languageOptions = languageSelector.querySelectorAll(".sl-flag");
            languageOptions.forEach((flagElement)=>{
                const parentElement = flagElement.parentElement;
                const elementLang = flagElement.getAttribute("data-lang");
                if (elementLang) {
                    if (elementLang.toLowerCase() === (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase()) {
                        const nextSibling = flagElement.nextElementSibling;
                        if (nextSibling) nextSibling.classList.add("active");
                        this.selectLanguage((0, $58070e9281bc680d$export$3814be8b8b1016be)());
                    }
                }
                if (parentElement) // eslint-disable-next-line @typescript-eslint/no-unused-vars
                parentElement.addEventListener("click", (event)=>{
                    const selectedLanguageCode = flagElement.getAttribute("data-lang");
                    window.lang = selectedLanguageCode || (0, $58070e9281bc680d$export$3814be8b8b1016be)();
                    languageOptions.forEach((option)=>{
                        const span = option.parentElement?.querySelector("span");
                        span?.classList.remove("active");
                    });
                    const nextSibling = flagElement.nextElementSibling;
                    if (selectedLanguageCode) this.selectLanguage(selectedLanguageCode);
                    if (nextSibling) nextSibling.classList.add("active");
                });
            });
        }
    }
    selectLanguage(languageCode) {
        const langElement = document.getElementById("selectdLang");
        if (langElement) langElement.innerHTML = `<b>${languageCode.toString().toUpperCase()}</b>`;
        this.emit("language_changed", languageCode);
    }
    updateSessionCountdown() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        const minutes = Math.floor(this.sessionDuration / 60);
        const seconds = this.sessionDuration % 60;
        if (countdownElement && $lnkReset) {
            countdownElement.innerHTML = `${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.sessionReset} <span style="color: red;font-family: monospace;font-weight:500">${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}</span> ${minutes < 1 ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.seconds : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.minute}`;
            $lnkReset.style.visibility = "visible";
            this.sessionDuration--;
            if (this.sessionDuration < 0) {
                clearInterval(this.countdownInterval);
                this.sessionDuration = this.TIMEOUT_LIMIT;
                countdownElement.textContent = "";
                this.resetMap();
            }
        }
    }
    startSessionCountdown() {
        this.sessionDuration = this.TIMEOUT_LIMIT;
        this.clearCountdownInterval();
        this.countdownInterval = setInterval(this.updateSessionCountdown, 1000);
    }
    clearCountdownInterval() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = 0;
        }
    }
    resetMap() {
        const countdownElement = document.getElementById("countdownText");
        const $lnkReset = document.getElementById("lnkReset");
        if (countdownElement && $lnkReset) {
            countdownElement.textContent = "";
            $lnkReset.style.visibility = "hidden";
        }
        this.sendGAEvent();
        this.clearCountdownInterval();
        this.isMapReloaded = !this.isMapReloaded;
        this.emit("map_reload", this.isMapReloaded);
    // location.reload();
    }
    sendGAEvent() {
        const currentTimeMillis = new Date().getTime();
        const currentUnixTimestamp = Math.floor(currentTimeMillis / 1000);
        const queryParam = this.state.query?.split("=");
        const kiosk = queryParam && queryParam?.length > 1 ? queryParam[1] : "";
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "session_rest",
            timestamps: currentUnixTimestamp,
            content_id: kiosk,
            items: undefined,
            search_term: undefined,
            item_name: undefined,
            nav_from: undefined,
            nav_to: undefined,
            content_type: undefined
        });
    }
    removeExistingMarquees() {
        const marquees = document.querySelectorAll(".marquee-content");
        if (marquees.length > 0) marquees.forEach((el)=>{
            el.remove();
        });
    }
    restartMarqueeAnimation(selector) {
        requestAnimationFrame(()=>{
            const marquees = document.querySelectorAll(selector);
            marquees.forEach((el)=>{
                el.style.animation = "none"; // Stop the animation
                el.offsetWidth; // Force reflow
                el.style.animation = ""; // Restart animation
            });
        });
    }
    constructor(...args){
        super(...args);
        this.allSponsors = [];
        this.marqueeRows = [
            [],
            [],
            [],
            []
        ];
        this.TIMEOUT_LIMIT = 60;
        this.isMapReloaded = false;
    }
}


function $e7190a203d7b16c2$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $e7190a203d7b16c2$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $e7190a203d7b16c2$var$passiveTestOptions = {
        get passive () {
            $e7190a203d7b16c2$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $e7190a203d7b16c2$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $e7190a203d7b16c2$var$passiveTestOptions);
}
var $e7190a203d7b16c2$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $e7190a203d7b16c2$var$locks = [];
var $e7190a203d7b16c2$var$documentListenerAdded = false;
var $e7190a203d7b16c2$var$initialClientY = -1;
var $e7190a203d7b16c2$var$previousBodyOverflowSetting = void 0;
var $e7190a203d7b16c2$var$previousBodyPosition = void 0;
var $e7190a203d7b16c2$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $e7190a203d7b16c2$var$allowTouchMove = function allowTouchMove(el) {
    return $e7190a203d7b16c2$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $e7190a203d7b16c2$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($e7190a203d7b16c2$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $e7190a203d7b16c2$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($e7190a203d7b16c2$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $e7190a203d7b16c2$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($e7190a203d7b16c2$var$previousBodyOverflowSetting === undefined) {
        $e7190a203d7b16c2$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $e7190a203d7b16c2$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($e7190a203d7b16c2$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $e7190a203d7b16c2$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $e7190a203d7b16c2$var$previousBodyPaddingRight = undefined;
    }
    if ($e7190a203d7b16c2$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $e7190a203d7b16c2$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $e7190a203d7b16c2$var$previousBodyOverflowSetting = undefined;
    }
};
var $e7190a203d7b16c2$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($e7190a203d7b16c2$var$previousBodyPosition === undefined) {
            $e7190a203d7b16c2$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $e7190a203d7b16c2$var$restorePositionSetting = function restorePositionSetting() {
    if ($e7190a203d7b16c2$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $e7190a203d7b16c2$var$previousBodyPosition.position;
        document.body.style.top = $e7190a203d7b16c2$var$previousBodyPosition.top;
        document.body.style.left = $e7190a203d7b16c2$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $e7190a203d7b16c2$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $e7190a203d7b16c2$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $e7190a203d7b16c2$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $e7190a203d7b16c2$var$initialClientY;
    if ($e7190a203d7b16c2$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $e7190a203d7b16c2$var$preventDefault(event);
    if ($e7190a203d7b16c2$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $e7190a203d7b16c2$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $e7190a203d7b16c2$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($e7190a203d7b16c2$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $e7190a203d7b16c2$var$locks = [].concat($e7190a203d7b16c2$var$_toConsumableArray($e7190a203d7b16c2$var$locks), [
        lock
    ]);
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$setPositionFixed();
    else $e7190a203d7b16c2$var$setOverflowHidden(options);
    if ($e7190a203d7b16c2$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $e7190a203d7b16c2$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $e7190a203d7b16c2$var$handleScroll(event, targetElement);
        };
        if (!$e7190a203d7b16c2$var$documentListenerAdded) {
            document.addEventListener("touchmove", $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = true;
        }
    }
};
var $e7190a203d7b16c2$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($e7190a203d7b16c2$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $e7190a203d7b16c2$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($e7190a203d7b16c2$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $e7190a203d7b16c2$var$initialClientY = -1;
    }
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$restorePositionSetting();
    else $e7190a203d7b16c2$var$restoreOverflowSetting();
    $e7190a203d7b16c2$var$locks = [];
};
var $e7190a203d7b16c2$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $e7190a203d7b16c2$var$locks = $e7190a203d7b16c2$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($e7190a203d7b16c2$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($e7190a203d7b16c2$var$documentListenerAdded && $e7190a203d7b16c2$var$locks.length === 0) {
            document.removeEventListener("touchmove", $e7190a203d7b16c2$var$preventDefault, $e7190a203d7b16c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $e7190a203d7b16c2$var$documentListenerAdded = false;
        }
    }
    if ($e7190a203d7b16c2$var$isIosDevice) $e7190a203d7b16c2$var$restorePositionSetting();
    else $e7190a203d7b16c2$var$restoreOverflowSetting();
};


var $b2f05b2db7d8ade3$export$54f5f69c1651567f;
(function(WidgetEvents) {
    WidgetEvents["AUTOCOMPLETE"] = "AUTOCOMPLETE";
    WidgetEvents["POI_SELECTED"] = "POI_SELECTED";
    WidgetEvents["PHONE_CLICKED"] = "PHONE_CLICKED";
    WidgetEvents["WEBSITE_CLICKED"] = "WEBSITE_CLICKED";
    WidgetEvents["SEARCH_RESULT_ITEM_SELECTED"] = "SEARCH_RESULT_ITEM_SELECTED";
    WidgetEvents["FIND_ROUTE"] = "FIND_ROUTE";
    WidgetEvents["NAVIGATION_STARTED"] = "NAVIGATION_STARTED";
})($b2f05b2db7d8ade3$export$54f5f69c1651567f || ($b2f05b2db7d8ade3$export$54f5f69c1651567f = {}));
var $b2f05b2db7d8ade3$export$6955bcca4cd3539f;
(function(Page) {
    Page["EXHIBITORS"] = "exhibitors";
    Page["THEMATIC"] = "thematic";
    Page["KIOSK"] = "kiosk";
    Page["GENERAL"] = "general";
})($b2f05b2db7d8ade3$export$6955bcca4cd3539f || ($b2f05b2db7d8ade3$export$6955bcca4cd3539f = {}));
var $b2f05b2db7d8ade3$export$5b5e3de1740177a6;
(function(DefaultMapOptions) {
    DefaultMapOptions[DefaultMapOptions["tilt"] = 80] = "tilt";
    DefaultMapOptions[DefaultMapOptions["heading"] = -14.39] = "heading";
    DefaultMapOptions[DefaultMapOptions["centerLat"] = 45.51908] = "centerLat";
    DefaultMapOptions[DefaultMapOptions["centerLng"] = 9.08109] = "centerLng";
    DefaultMapOptions[DefaultMapOptions["zoom"] = 17] = "zoom";
    DefaultMapOptions[DefaultMapOptions["minZoomAllowed"] = 14] = "minZoomAllowed";
    DefaultMapOptions[DefaultMapOptions["kioskZoom"] = 17.5] = "kioskZoom";
    DefaultMapOptions[DefaultMapOptions["kioskTilt"] = 45] = "kioskTilt";
    DefaultMapOptions[DefaultMapOptions["kioskHeading"] = 26.39] = "kioskHeading";
})($b2f05b2db7d8ade3$export$5b5e3de1740177a6 || ($b2f05b2db7d8ade3$export$5b5e3de1740177a6 = {}));

class $b2f05b2db7d8ade3$export$2e2bcd8739ae039 extends (0, $403d562f8e068716$export$2e2bcd8739ae039) {
    init() {}
    render() {
        (0, $58070e9281bc680d$export$e6103b0362967aab)(this.state.locale || (0, $58070e9281bc680d$export$9a2147b3808d4c6b));
        (0, $ec948a4cf72a2ce9$export$940a7873bb071df8)(this.state.config);
        this.preloadLinks();
        this.mapComponent = new (0, $0f8c890e7395704d$export$2e2bcd8739ae039)({
            $target: document.getElementById("app"),
            initialState: {
                woosmapPublicKey: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey,
                mapOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions,
                indoorRendererOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorRendererOptions,
                indoorWidgetOptions: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.indoorWidgetOptions,
                libraries: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.libraries,
                query: this.state.config?.map.query
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).MAP_READY, ()=>{
            this.mapComponent.initIndoorView();
            this.loadGoogleTagManager();
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).MAP_IDLE, ()=>{
            if (this.mapComponent.map.getZoom() < 14) {
                const zoom = this.currentPage === "kiosk" ? 17.5 : 17;
                const center = this.currentPage === "kiosk" ? {
                    lat: this.currentKiosk.lat,
                    lng: this.currentKiosk.lng
                } : {
                    lat: 45.51908,
                    lng: 9.08109
                };
                this.mapComponent.map.setZoom(zoom);
                this.mapComponent.map.panTo(center);
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_VENUE_LOADED, (venue)=>{
            console.log("Venue loaded ", venue);
            this.venue = venue;
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            // Do any actions here when indoor venue is fully loaded
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.currentPage = "kiosk";
                this.fetchKiosksData().then((kiosks)=>{
                    const queryParam = this.state.query?.split("=");
                    if (queryParam && queryParam.length > 0 && kiosks) {
                        const filteredKiosk = kiosks?.find((item)=>item.title.toLowerCase() === queryParam[1].toLowerCase());
                        this.isKiosk = true;
                        this.currentKiosk = filteredKiosk;
                        if (filteredKiosk) this.mapComponent.setOrigin(filteredKiosk);
                    }
                }).catch((error)=>{
                    console.error("Error in reading kiosk data", error);
                });
                this.mapComponent.turnOffNavigation();
                if (this.kioskComponent === undefined) {
                    this.kioskComponent = new (0, $67dc1e3ffb36eb73$export$2e2bcd8739ae039)({
                        $target: document.getElementById("wrapper"),
                        initialState: {
                            query: this.state.query
                        }
                    });
                    this.displayKioskElements();
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).LOGO_CLICKED, (ref)=>{
                        if (this.currentKiosk) this.mapComponent.showRouteForSponsor({
                            lat: this.currentKiosk.lat,
                            lng: this.currentKiosk.lng
                        }, ref);
                    });
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).LANGUAGE_CHANGED, (lang)=>{
                        this.setState({
                            locale: lang
                        });
                    });
                    this.kioskComponent.on((0, $67dc1e3ffb36eb73$export$e163f07d771b24a3).MAP_RELOAD, ()=>{
                        this.mapComponent.destroyMap();
                        const btnAllExhibits = document.getElementById("btnAllExhibits");
                        if (btnAllExhibits) btnAllExhibits.classList.add("active");
                        const btnThematic = document.getElementById("btnThematic");
                        if (btnThematic) btnThematic.classList.remove("active");
                    });
                }
            }
            if (this.state.query && this.state.query !== "" && this.state.query.includes("thematic")) {
                const selectedTheme = this.state.query.split("=")[1];
                this.selectedThematic = selectedTheme;
                this.itemsForThematicSelected = [];
                if (selectedTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && selectedTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.mapComponent.setFilter(selectedTheme);
                window.dataLayer = window.dataLayer || [];
                if (this.selectedThematic && this.selectedThematic !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && this.selectedThematic !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.getPOIExtendedData(undefined, this.state.query).then((pois)=>{
                    window.dataLayer = window.dataLayer || [];
                    this.itemsForThematicSelected = pois;
                    window.dataLayer.push({
                        event: "woo_filter",
                        content_type: "thematic",
                        content_id: this.selectedThematic,
                        parent_content_type: undefined,
                        parent_content_id: undefined,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined
                    });
                }).catch((error)=>{
                    console.error("Error while searching POIs:", error);
                });
            // this.createResetMapElemnt();
            }
            this.initThematicComponent();
        /*
            if (width <= getConfig().map.mobileBreakPoint) {
                // this.mapComponent.map.setZoom(DefaultMapOptions.zoom + 0.5);
                this.manageNativeKeyboardIssues();
            }
            */ });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_WIDGET_ANALYTICS, (event)=>{
            if (this.state.query && this.state.query !== "" && this.state.query.includes("kiosk")) {
                this.currentPage = "kiosk";
                this.kioskComponent.startSessionCountdown();
            }
            if (event.event === "AUTOCOMPLETE" && event.args.query.length >= 3) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_search",
                    search_term: event.args.query,
                    items: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
                const searchResults = event.args.results;
                const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                if (this.selectedThematic && this.selectedThematic !== "" && this.selectedThematic !== "sdm_default") {
                    const pois = this.createPOIListForAnalytics(searchResults, this.selectedThematic);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "woo_poi_search_list",
                        content_type: thematic,
                        items: pois,
                        _clear: true,
                        search_term: undefined,
                        content_id: undefined,
                        item_name: undefined,
                        nav_from: undefined,
                        nav_to: undefined,
                        parent_content_type: undefined,
                        parent_content_id: undefined
                    });
                } else /* As far as possible avoid calling /search endpoint */ if (searchResults && searchResults.length > 0) {
                    // const refs: string = searchResults.map((element: SearchResult) => `ref:${element.ref}`).join(',');
                    const ids = searchResults.map((element)=>element.id).join(",");
                    this.getPOIExtendedData(ids).then((pois)=>{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "woo_poi_search_list",
                            content_type: thematic,
                            items: pois,
                            _clear: true,
                            search_term: undefined,
                            content_id: undefined,
                            item_name: undefined,
                            nav_from: undefined,
                            nav_to: undefined,
                            parent_content_type: undefined,
                            parent_content_id: undefined
                        });
                    }).catch((error)=>{
                        console.error("Error while searching POIs:", error);
                    });
                }
            }
            if (event.event === "SEARCH_RESULT_ITEM_SELECTED") {
                const poi = event.args;
                console.log("SEARCH_RESULT_ITEM_SELECTED", poi);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_poi_search_clic",
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "FIND_ROUTE") {
                if (this.infoWindow) this.infoWindow.close();
                const poi = event.args;
                // Comment this if something goes wrong in multi level warning changes !!!
                if (this.currentPage === "kiosk") // this.mapComponent.map.setHeading(DefaultMapOptions.kioskHeading);
                this.checkForMultilevelDirections();
                // const tilt = this.currentPage === Page.KIOSK ? DefaultMapOptions.kioskTilt : DefaultMapOptions.tilt;
                // this.mapComponent.map.setTilt(tilt);
                // this.mapComponent.map.panTo({lat: DefaultMapOptions.centerLat, lng: DefaultMapOptions.centerLng})
                this.mapComponent.showRouteForAllLevels();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_clic_iti",
                    content_type: poi.destination.properties["thematic"] ? poi.destination.properties["thematic"] : "",
                    content_id: poi.destination.properties["POI_ID"],
                    item_name: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
            if (event.event === "NAVIGATION_STARTED") {
                const poi = event.args;
                let origin = poi.origin.properties["name"];
                if (poi.origin.id === -1) origin = this.isKiosk && this.currentKiosk ? `Kiosk ${this.currentKiosk.title}` : poi.origin.properties["name"];
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "woo_nav",
                    nav_from: origin,
                    nav_to: poi.destination.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    item_name: undefined,
                    content_type: undefined,
                    content_id: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).INDOOR_POI_ON_MAP_CLICK, (poi)=>{
            if (poi) {
                if ((0, $ee9cb80b5c23ac97$export$7d9f9b4046392aed)()) requestAnimationFrame(()=>{
                    const closePanelBtn = document.getElementsByClassName("btn btn--retract desktop")[0];
                    const itineraryPanel = document.getElementsByClassName("woosmap-panel__content itinerary")[0];
                    if (closePanelBtn && !itineraryPanel) closePanelBtn.click();
                });
                window.dataLayer.push({
                    event: "woo_poi_map_clic",
                    content_type: poi.properties["thematic"] ? poi.properties["thematic"] : "",
                    content_id: poi.properties["POI_ID"],
                    item_name: poi.properties["name"],
                    items: undefined,
                    search_term: undefined,
                    nav_from: undefined,
                    nav_to: undefined
                });
                if (this.mapType === "favorites") {
                    if (poi && poi.properties) {
                        if (poi.properties["Exhibitor_Name"] === undefined || poi.properties["Building"] === undefined || poi.properties["Floorplan_Label"] === undefined) return;
                    }
                    this.getUserFavoriteShops(this.loggedInUser).then((favorites)=>{
                        if (favorites && favorites.data.length > 0) {
                            const isPoiFav = favorites.data.map((fav)=>{
                                return fav;
                            }).filter((fav)=>fav.exhibitor_id === poi.properties.Salesforce_ID);
                            if (isPoiFav && isPoiFav.length > 0) this.openCustomInfoWindow(poi, true);
                            else this.openCustomInfoWindow(poi, false);
                        } else this.openCustomInfoWindow(poi, false);
                    }).catch((error)=>{
                        console.error("Error in fetching favorites", error);
                    });
                } else if (this.state.source && this.state.source !== "kiosk") this.openCustomInfoWindow(poi, false);
            }
        });
        this.mapComponent.on((0, $0f8c890e7395704d$export$715fed9478e7c158).FAVORITE_MARKER_CLICKED, (poi)=>{
            poi;
        });
    }
    async fetchKiosksData() {
        try {
            const kioskModule = await (parcelRequire("dyfc6"));
            const kioskData = kioskModule.default;
            return kioskData.kiosks;
        } catch (error) {
            console.error("Error importing Kiosk JSON file:", error);
        }
    }
    preloadLinks() {
        Promise.all([
            // preloadLink({
            //     url: getConfig().urls.mapJS,
            //     params: { key: getConfig().map.woosmapPublicKey, language: getLocaleLang().toLowerCase(), libraries: getConfig().map.libraries },
            //     as: "script",
            // }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/tiles.json",
                params: {
                    key: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://api.woosmap.com/maps/style/streets.json",
                params: {
                    language: (0, $58070e9281bc680d$export$3814be8b8b1016be)().toLowerCase(),
                    key: (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.woosmapPublicKey
                },
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.png",
                as: "fetch",
                crossOrigin: "anonymous"
            }),
            (0, $9bbb064cf4ce4d36$export$a0db4953bb08f589)({
                url: "https://sdk.woosmap.com/map/assets/sprite@2x.json",
                as: "fetch",
                crossOrigin: "anonymous"
            })
        ]);
    }
    createResetMapElemnt() {
        const $mapContainer = document.getElementById("map");
        const $btnToggle = document.getElementById("btnSwitchStandardView");
        if ($mapContainer && !$btnToggle) {
            const toggleStandardView = document.createElement("button");
            toggleStandardView.id = "btnSwitchStandardView";
            toggleStandardView.classList.add("toggle-standard-view");
            toggleStandardView.innerText = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.cta["switch_standard_view"];
            toggleStandardView.addEventListener("click", ()=>{
                // location.reload();
                window.location.href = window.location.origin + window.location.pathname;
            });
            $mapContainer.appendChild(toggleStandardView);
        }
    }
    applyTheme(theme) {
        const { config: config } = this.state;
        if (theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] || theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.setState({
            query: ""
        });
        if (config) {
            const mapConfig = config.map;
            const updatedMapOptions = {
                ...mapConfig,
                indoorRendererOptions: {
                    theme: theme,
                    ...theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"] && {
                        baseFilter: `thematic:=${theme} OR ${theme}:=true`
                    }
                },
                indoorWidgetOptions: {
                    ...theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"] && {
                        baseFilter: `thematic:=${theme} OR ${theme}:=true`
                    }
                }
            };
            const updatedConfig = {
                ...config,
                map: updatedMapOptions
            };
            this.setState({
                config: updatedConfig
            });
        }
        if (this.mapComponent && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && theme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) this.mapComponent.setFilter(theme);
    }
    getPOIExtendedData(ids, filter) {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            const arrPOIs = [];
            const callback = (featuresCollection)=>{
                if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) {
                    featuresCollection.features.forEach((element)=>{
                        const properties = element.properties;
                        const searchedPOI = {
                            item_id: properties["ref"],
                            item_name: properties["name"],
                            item_category: properties["thematic"],
                            quantity: 1
                        };
                        arrPOIs.push(searchedPOI);
                    });
                    resolve(arrPOIs);
                } else reject(new Error("No features found."));
            };
            indoorService.search(this.venue.venue_id, "", callback, null, ids, filter);
        });
    }
    createPOIListForAnalytics(results, thematic) {
        const arrPOIs = [];
        results.forEach((element)=>{
            const searchedPOI = {
                item_id: element.ref,
                item_name: element.name,
                item_category: thematic,
                quantity: 1
            };
            arrPOIs.push(searchedPOI);
        });
        return arrPOIs;
    }
    loadGoogleTagManager() {
        console.log("Google Tag Manager ", (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.GATag);
        const gaTrackingId = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.GATag;
        if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}"]`)) (function(w, d, s, l, i) {
            w.dataLayer = w.dataLayer || [];
            w.dataLayer.push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            const dl = l !== "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gaTrackingId);
    }
    computeBoundsOfBuildingSelected(buildingList) {
        if (buildingList["pavilion"]) {
            const mergedBounds = new woosmap.map.LatLngBounds();
            buildingList["pavilion"].forEach((item)=>{
                if (this.venue && this.venue.buildings && this.venue.buildings.length > 0) {
                    const filteredBuilding = this.venue.buildings.filter((building)=>building.ref === item)[0];
                    if (filteredBuilding && filteredBuilding.levels.length > 0) {
                        const bbox = filteredBuilding.levels.filter((level)=>level.level === 0)[0].bbox;
                        const bounds = new woosmap.map.LatLngBounds({
                            lng: bbox[0],
                            lat: bbox[1]
                        }, {
                            lng: bbox[2],
                            lat: bbox[3]
                        });
                        const position = {
                            lat: bounds.getCenter().lat(),
                            lng: bounds.getCenter().lng()
                        };
                        mergedBounds.extend(position);
                    }
                }
            });
            const newPosition = {
                lat: mergedBounds.getCenter().lat(),
                lng: mergedBounds.getCenter().lng()
            };
            this.mapComponent.map.panTo(newPosition);
        }
    }
    resetMap() {
        const defaultOptions = {
            bearing: -14.39,
            animate: true,
            duration: 500
        };
        let mergedOptions;
        let zoom = 17;
        if (this.currentPage === "general") {
            mergedOptions = {
                ...defaultOptions,
                center: this.thematicCenter,
                zoom: 17
            };
            zoom = 17;
        } else if (this.currentPage === "kiosk") {
            if (this.currentKiosk) {
                mergedOptions = {
                    ...defaultOptions,
                    center: {
                        lat: this.currentKiosk.lat,
                        lng: this.currentKiosk.lng
                    },
                    zoom: 17.5,
                    pitch: 45,
                    bearing: 26.39
                };
                zoom = 17.5;
            }
        }
        if (mergedOptions && zoom) {
            this.mapComponent.map.flyTo(mergedOptions);
            setTimeout(()=>{
                this.mapComponent.map.setZoom(zoom);
            }, 550);
        }
    }
    showMultiLevelWarning() {
        const $mapElement = document.querySelector(".mapboxgl-control-container");
        if ($mapElement) {
            const $infoContainer = document.createElement("div");
            $infoContainer.classList.add("mapboxgl-ctrl-top-center", "fade-in-out");
            setTimeout(()=>{
                $infoContainer.classList.add("show");
            }, 200);
            const $info = document.createElement("div");
            $info.id = "map-info";
            $info.innerHTML = (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.multilevelwarning;
            $infoContainer.appendChild($info);
            $mapElement.appendChild($infoContainer);
            setTimeout(()=>{
                $infoContainer.classList.remove("show");
            }, 10000);
        }
    }
    groupInstructionsByLevel(steps) {
        const instructionsByLevel = [];
        let lastStepsByLevel = {
            level: null,
            steps: []
        };
        steps.forEach((step)=>{
            if (lastStepsByLevel.level !== step.properties.level) {
                lastStepsByLevel = {
                    level: step.properties.level,
                    steps: []
                };
                instructionsByLevel.push(lastStepsByLevel);
            }
            lastStepsByLevel.steps.push(step);
        });
        return instructionsByLevel;
    }
    checkForMultilevelDirections() {
        const directionsResult = this.mapComponent.getDirections();
        if (directionsResult && directionsResult.routes && directionsResult.routes.length > 0) {
            const route = directionsResult.routes[0];
            const routeSteps = [];
            if (route.legs && route.legs.length > 0) {
                route.legs.forEach((leg)=>{
                    if (leg && leg.steps) leg.steps.forEach((step)=>{
                        const feature = {
                            type: "Feature",
                            properties: {
                                id: `${route.legs.indexOf(leg)}_${leg.steps.indexOf(step)}`,
                                level: `Level ${step.start_location.level}`,
                                floor: step.start_location.level,
                                instruction: step.instruction ? step.instruction.summary : null,
                                icon: step.instruction && step.instruction.instruction_type ? step.instruction.instruction_type : "caret-down"
                            },
                            geometry: {
                                type: "LineString",
                                coordinates: step.polyline
                            }
                        };
                        routeSteps.push(feature);
                    });
                });
                if (routeSteps.length > 0) {
                    const levelsGroup = this.groupInstructionsByLevel(routeSteps);
                    if (levelsGroup.length > 2) this.showMultiLevelWarning();
                }
            }
        }
    }
    resetTheme(theme) {
        if (this.mapComponent) this.mapComponent.setFilter(theme);
    }
    setBoundsOnDirectionsChanged(start, end) {
        const routeBounds = new woosmap.map.LatLngBounds();
        routeBounds.extend({
            lat: start.coordinates[1],
            lng: start.coordinates[0]
        });
        if (end.type === "Polygon") end.coordinates[0].forEach((coord)=>routeBounds.extend({
                lat: coord[1],
                lng: coord[0]
            }));
        else if (end.type === "Point") routeBounds.extend({
            lat: end.coordinates[1],
            lng: end.coordinates[0]
        });
        this.mapComponent.map.fitBounds(routeBounds, {
            top: 20,
            left: 390,
            right: 70,
            bottom: 20
        }, true);
    }
    async getUserFavoriteShops(token) {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        try {
            const response = await fetch(`${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.lambdaExternal}?token=${token}&status=tovisit`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 400) {
                const errorData = await response.json();
                console.error("Bad Request: 400", errorData.message);
                (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().messages.api_error, "error");
                return;
            }
            if (!response.ok) {
                const errorData = await response.json();
                (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().messages.api_error, "error");
                throw new Error(`HTTP error: ${response.status}, ${errorData.message}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error occurred:", error);
        }
    }
    getPOIDataForFavorites(favorites) {
        return new Promise((resolve, reject)=>{
            const indoorService = new woosmap.map.IndoorService();
            if (favorites && favorites.length > 0) {
                const advanced_filter = favorites.map((favorite)=>`Salesforce_ID:=${favorite}`).join(" OR ");
                const callback = (featuresCollection)=>{
                    if (featuresCollection && featuresCollection.features && featuresCollection.features.length > 0) resolve(featuresCollection);
                    else reject(new Error("No features found."));
                };
                indoorService.search(this.venue.venue_id, "", callback, null, null, advanced_filter);
            }
        });
    }
    showUserFavoritesOnMap(favorites) {
        if (favorites && favorites.length > 0) this.getPOIDataForFavorites(favorites).then((featuresCollection)=>{
            console.log("Woosmap POI data for favorites", featuresCollection.features);
            this.mapComponent.plotUserFavoritesOnMap(featuresCollection.features);
        });
    }
    openCustomInfoWindow(feature, isFav = false) {
        console.log("Inside openCustomInfoWindow");
        if (feature) {
            if (this.infoWindow) this.infoWindow.close();
            this.infoWindow = new woosmap.map.InfoWindow({
                content: "",
                disableAutoPan: true
            });
            const logo = feature.properties["woosmap:logo"];
            const logoImageStyle = `background-image: url(${logo})`;
            const poiName = feature.properties["name"];
            let customHTML = "";
            const favText = isFav ? `- ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.remove_favorites}` : `+ ${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.add_favorites}`;
            if (this.loggedInUser && this.mapType === "favorites") customHTML = `<div class="infowindow-wrapper-favs">
                <div class="infowindow-logo" style="${logoImageStyle}"></div>
                <div class="infowindow-content"><span class="title">${poiName}</span>
                <span class="pav-info">${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.level} ${feature.properties["level"]}</span>
                <span class="favs-link">${favText}</span>
                </div></div></div></div>`;
            else customHTML = `<div class="infowindow-wrapper">
            <div class="infowindow-logo" style="${logoImageStyle}"></div>
            <div class="infowindow-content"><span class="title">${poiName}</span>
            <span class="level">${(0, $58070e9281bc680d$export$180605366c04f0cd)().messages.level} ${feature.properties["level"]}</span>
            </div></div>`;
            this.infoWindow.setContent(customHTML);
            if (isFav) this.infoWindow.setOffset(new woosmap.map.Point(0, -30));
            const pos = (0, $ee9cb80b5c23ac97$export$53fc19a32de59f94)(feature);
            this.infoWindow.open(this.mapComponent.map, pos);
            if (this.mapType === "favorites") document.getElementsByClassName("favs-link")[0].addEventListener("click", ()=>{
                const status = isFav ? `none` : `tovisit`;
                this.flagUserFavorites(feature, status).then(()=>{
                    const message = isFav ? (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.remove_favorites_toast : (0, $58070e9281bc680d$export$180605366c04f0cd)().messages.add_favorites_toast;
                    const toastType = isFav ? "error" : "success";
                    this.mapComponent.unselectPOI();
                    (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)(message, toastType);
                    this.getUserFavoriteShops(this.loggedInUser).then((favorites)=>{
                        if (favorites && favorites.data.length > 0) {
                            const favoriteShops = favorites.data.map((favorite)=>favorite.exhibitor_id);
                            this.showUserFavoritesOnMap(favoriteShops);
                        } else this.mapComponent.removeMarkersForFavs();
                        if (this.infoWindow) this.infoWindow.close();
                    }).catch((error)=>{
                        console.error("Error in fetching favorites", error);
                    });
                });
            });
            let flyToOptions = {
                center: pos,
                padding: (0, $ee9cb80b5c23ac97$export$3ba45bd218cae310)(true)
            };
            flyToOptions = this.mapComponent.map.getZoom() < 18 ? {
                ...flyToOptions,
                zoom: 18
            } : flyToOptions;
            this.mapComponent.map.flyTo(flyToOptions);
        }
    }
    async flagUserFavorites(feature, status) {
        try {
            const body = {
                "token": this.loggedInUser,
                "exhibitorIds": [
                    feature.properties["Salesforce_ID"]
                ],
                status: status
            };
            const response = await fetch((0, $ec948a4cf72a2ce9$export$44487a86467333c3)().urls.lambdaExternal, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                (0, $ee9cb80b5c23ac97$export$f6cef6fcf9ca4e17)((0, $58070e9281bc680d$export$180605366c04f0cd)().messages.api_error, "error");
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error occurred:", error);
            return Promise.reject(`Fetch failed: ${error}`);
        }
    }
    displayKioskElements() {
        const $mapContainer = document.getElementById("map");
        $mapContainer.style.visibility = "visible";
        const $kioskHeader = document.getElementsByClassName("kiosk-header");
        if ($kioskHeader && $kioskHeader[0]) $kioskHeader[0].style.visibility = "visible";
        const $mapSwitcher = document.getElementsByClassName("button-section");
        if ($mapSwitcher && $mapSwitcher[0]) $mapSwitcher[0].style.visibility = "visible";
    }
    initThematicComponent() {
        let defaultTheme = this.state.config?.map.indoorRendererOptions.theme || "";
        if (defaultTheme && defaultTheme !== "" && defaultTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["default"] && defaultTheme !== (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes["favorites"]) defaultTheme = `thematic:=${defaultTheme.substring(0, defaultTheme.indexOf("_"))}`;
        this.thematicComponent = new (0, $3c0730fc6dc90d7f$export$2e2bcd8739ae039)({
            $target: document.querySelector("button-section"),
            initialState: {
                query: this.state.query?.includes("thematic") ? this.state.query : defaultTheme,
                showDescription: true
            }
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).THEMATIC_SELECTED, (thematic)=>{
            if (this.currentPage === "kiosk") this.kioskComponent.startSessionCountdown();
            const selectedTheme = thematic.split("=")[1];
            this.selectedThematic = selectedTheme;
            this.itemsForThematicSelected = [];
            this.mapComponent.setFilter(selectedTheme);
            this.mapComponent.setTheme(`${selectedTheme}_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}`);
            this.mapComponent.unselectPOI();
            this.mapType = "thematics";
            this.mapComponent.removeMarkersForFavs();
            if (this.infoWindow) this.infoWindow.close();
            const initialCenter = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions.center;
            if (this.mapComponent.map.getCenter() !== initialCenter) {
                this.mapComponent.map.panTo(this.thematicCenter);
                setTimeout(()=>{
                    this.mapComponent.map.setZoom(17);
                }, 500);
            }
            if (this.selectedThematic && this.selectedThematic !== `sdm_default_${(0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.eventYear}`) this.getPOIExtendedData(undefined, thematic).then((pois)=>{
                window.dataLayer = window.dataLayer || [];
                this.itemsForThematicSelected = pois;
                window.dataLayer.push({
                    event: "woo_filter",
                    content_type: "thematic",
                    content_id: this.selectedThematic,
                    items: pois,
                    _clear: true,
                    search_term: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined,
                    parent_content_type: undefined,
                    parent_content_id: undefined
                });
            }).catch((error)=>{
                console.error("Error while searching POIs:", error);
            });
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).BUILDING_SELECTED, (buildingList)=>{
            if (this.currentPage === "kiosk") {
                this.kioskComponent.startSessionCountdown();
                this.itemsForThematicSelected = [];
            }
            if (buildingList) {
                if (buildingList && buildingList.ref && buildingList.ref === "pav2_4") {
                    console.log("Hardwired fixed for wrong bounds");
                    this.mapComponent.map.panTo({
                        lat: buildingList.center.lat,
                        lng: buildingList.center.lng
                    });
                } else this.computeBoundsOfBuildingSelected(buildingList);
                const thematic = this.selectedThematic && this.selectedThematic !== "sdm_default" ? this.selectedThematic : "";
                window.dataLayer.push({
                    event: "woo_filter",
                    content_type: "pav",
                    content_id: buildingList.title,
                    parent_content_type: "thematic",
                    parent_content_id: thematic,
                    items: this.itemsForThematicSelected && this.itemsForThematicSelected.length > 0 ? this.itemsForThematicSelected : undefined,
                    search_term: undefined,
                    item_name: undefined,
                    nav_from: undefined,
                    nav_to: undefined
                });
            } else this.resetMap();
        });
        this.thematicComponent.on((0, $3c0730fc6dc90d7f$export$834029a0b90ac2e7).THEMATIC_UNSELECTED, (theme)=>{
            if (this.currentPage === "kiosk") this.kioskComponent.startSessionCountdown();
            this.resetTheme(theme);
            this.mapComponent.setTheme(theme);
            this.mapComponent.unselectPOI();
            this.mapComponent.removeMarkersForFavs();
            this.mapType = "general";
            if (this.infoWindow) this.infoWindow.close();
            const initialCenter = (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.mapOptions.center;
            if (this.mapComponent.map.getCenter() !== initialCenter) {
                this.mapComponent.map.panTo(this.thematicCenter);
                setTimeout(()=>{
                    this.mapComponent.map.setZoom(17);
                }, 500);
            }
            if (theme === (0, $ec948a4cf72a2ce9$export$44487a86467333c3)().map.themes.favorites) {
                this.mapType = "favorites";
                const query = this.state.query;
                if (query && query.includes("token")) {
                    const token = query.split(":=")[1];
                    console.log("My token ", token);
                    this.loggedInUser = token;
                    const fetchFavorites = (token)=>{
                        this.getUserFavoriteShops(token).then((favorites)=>{
                            if (favorites && favorites.data.length > 0) {
                                console.log("User Favorites from SDM ", favorites);
                                const favoriteShops = favorites.data.map((favorite)=>favorite.exhibitor_id);
                                this.showUserFavoritesOnMap(favoriteShops);
                            }
                        }).catch((error)=>{
                            console.error("Error in fetching favorites", error);
                        });
                    };
                    if (token) fetchFavorites(token);
                }
            }
        });
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("token") && urlParams.has("path")) {
            const path = urlParams.get("path");
            if (path === "user_exhibitors") this.thematicComponent.switchMap("favorites");
        }
    }
    manageNativeKeyboardIssues() {
        const ulElement = document.getElementById("autoComplete_list_1");
        const searchInput = document.querySelector(".autoComplete_wrapper > input");
        const handleFocusIn = ()=>{
            if (ulElement && searchInput && window.visualViewport) {
                console.log("Prevent background scrolling");
                (0, $e7190a203d7b16c2$export$24fdf68abf432c44)(ulElement); // Prevent background scrolling
                const viewportHeight = window.visualViewport.height;
                const inputRect = searchInput.getBoundingClientRect();
                const availableHeight = viewportHeight - inputRect.bottom;
                console.log(availableHeight);
                ulElement.style.maxHeight = `${availableHeight}px !important`;
            }
        };
        const handleFocusOut = ()=>{
            if (ulElement) {
                console.log("Restore background scrolling");
                (0, $e7190a203d7b16c2$export$e5d0524c3725571e)(ulElement); // Restore background scrolling
                ulElement.style.maxHeight = "233px"; // Reset height
            }
        };
        if (searchInput) {
            searchInput.addEventListener("focus", handleFocusIn);
            searchInput.addEventListener("blur", handleFocusOut);
        }
    }
    constructor(...args){
        super(...args);
        this.isKiosk = false;
        this.currentPage = "general";
        this.thematicCenter = {
            lat: 45.51908,
            lng: 9.08109
        };
        this.loggedInUser = "";
        this.mapType = "general";
    }
}


window.woosmapIndoorWidget = (0, $b2f05b2db7d8ade3$export$2e2bcd8739ae039);


//# sourceMappingURL=index.eb7a3483.js.map
